export const ms = {
  translation: {
    nav: {
      dashboard: "Dashboard",
      orders: "Pesanan",
      transactions: "Transaksi",
      refunds: "Bayaran Balik",
      menu: "Menu",
      categories: "Kategori Menu",
      vouchers: "Baucar",
      bundles: "Pek Gabungan",
      stalls: "Gerai",
      stallApplications: "Permohonan Gerai",
      paymentMethods: "Kaedah Pembayaran",
      deliveryProviders: "Penyedia Penghantaran",
      smsProviders: "Penyedia SMS",
      banners: "Sepanduk Promosi",
      adminAccounts: "Akaun Pentadbir",
      staff: "Kakitangan",
      customers: "Pelanggan",
      reports: "Laporan",
      activity: "Log Aktiviti",
      flags: "Flag Ciri",
      pricingRules: "Peraturan Harga",
      hours: "Waktu & Cuti",
      legalContent: "Kandungan Undang-Undang",
      settings: "Tetapan",
      brandTitle: "Pentadbir Kopitiam",
      brandSubtitle: "Pusat Kawalan",
    },
    notFound: { title: "Halaman tidak wujud", desc: "Tiada halaman di alamat ini. Pautan mungkin telah tamat tempoh atau tersilap taip.", toDashboard: "Kembali ke papan pemuka", goBack: "Kembali" },
    common: {
      openMenu: "Buka navigasi",
      close: "Tutup",
      previousPage: "Sebelumnya",
      nextPage: "Seterusnya",
      save: "Simpan",
      cancel: "Batal",
      confirm: "Sahkan",
      delete: "Padam",
      edit: "Edit",
      create: "Cipta",
      refresh: "Muat Semula",
      loading: "Memuatkan…",
      noData: "Tiada data",
      total: "{{count}} rekod",
      success: "Berjaya",
      failed: "Operasi gagal, sila cuba lagi",
      signOut: "Log keluar",
      confirmDelete: "Padam item ini?",
      selectStall: "Pilih gerai",
      yes: "Ya",
      no: "Tidak",
      back: "Kembali",
      stall: "Gerai",
      saved: "Tersimpan",
      search: "Cari pesanan (no. / nama pelanggan / telefon), tekan Enter…",
      exportCsv: "Eksport CSV",
      clearFilters: "Kosongkan penapis",
      guest: "Tetamu",
      connectionTestOk: "{{message}}",
      connectionTestOkWithLatency: "{{message}} ({{ms}} ms)",
      connectionTestFailed: "{{message}}",
      system: "Sistem",
      switchLangEn: "English",
      switchLangZh: "中文",
      language: "Bahasa",
      swipeForMore: "Leret →",
      all: "Semua",
      active: "Aktif",
      disabled: "Dilumpuhkan",
      savePct: "Jimat RM {{amount}} ({{pct}}% diskaun)",
      pickupOnly: "Ambil sendiri sahaja",
      deliveryOnly: "Penghantaran sahaja",
      pickupAndDelivery: "Ambil sendiri & penghantaran",
      noExpiry: "Tiada tarikh luput",
      saveChanges: "Simpan perubahan",
      tablePageRange: "{{start}}–{{end}} daripada {{total}}",
    },
    auth: {
      brandName: "KawKaw Kopitiam",
      login: "Log Masuk Pentadbir",
      email: "E-mel",
      password: "Kata Laluan",
      loginBtn: "Log Masuk",
      loginFailed: "E-mel atau kata laluan tidak sah",
      loginErrorDetail: "E-mel atau kata laluan tidak sah. Sila cuba lagi.",
      brandTagline:
        "Konsol operasi — urus kedai, kakitangan, menu dan pesanan di satu tempat.",
      featureOrder: "Pengurusan pesanan langsung",
      featureStaff: "Kakitangan & kebenaran akses",
      featureReports: "Laporan jualan & analitik",
      featureSettings: "Tetapan kedai & jenama",
      copyright: "© 2026 KawKaw Kopitiam",
      welcomeBack: "Selamat kembali",
      signInSubtitle: "Log masuk dengan akaun pentadbir Anda untuk teruskan",
      emailLabel: "Alamat e-mel",
      passwordLabel: "Kata laluan",
      emailRequired: "Sila masukkan e-mel Anda",
      emailInvalid: "Sila masukkan e-mel yang sah",
      passwordRequired: "Sila masukkan kata laluan Anda",
      passwordPlaceholder: "Masukkan kata laluan Anda",
      signInBtn: "Log masuk →",
      demoCredentials: "🔑 Akaun demo",
      demoSuperLine: "{{email}} / {{password}} — Super admin",
      demoAdminLine: "{{email}} / {{password}} — Admin",
      emailPlaceholder: "admin@kawkaw.my",
    },
    orders: {
      title: "Pesanan",
      colOrderId: "ID Pesanan",
      colCustomer: "Pelanggan",
      colTotal: "Jumlah",
      colStatus: "Status",
      colPayment: "Pembayaran",
      colPlacedAt: "Ditempah Pada",
      searchPlaceholder: "Cari ID pesanan / pelanggan",
filteredByCustomer: "Ditapis mengikut pelanggan",
      filterStatus: "Tapis status",
      drawerStatus: "Status",
      drawerTotal: "Jumlah",
      drawerPayment: "Pembayaran",
      drawerCustomer: "Pelanggan",
      drawerPlaced: "Ditempah",
      drawerNotes: "Nota",
      drawerItems: "Item",
      drawerSubtotal: "Subjumlah",
      drawerDiscount: "Diskaun",
      drawerSST: "SST",
      drawerDelivery: "Yuran Penghantaran",
      status: {
        new: "Baru",
        pending: "Tertangguh",
        confirmed: "Disahkan",
        preparing: "Sedang Disediakan",
        ready: "Siap",
        completed: "Selesai",
        cancelled: "Dibatalkan",
        delivered: "Dihantar",
        out_for_delivery: "Dalam Penghantaran",
        in_transit: "Dalam Perjalanan",
      },
      type: {
        pickup: "Ambil Sendiri",
        delivery: "Penghantaran",
      },
      cancelSuccess: "Pesanan dibatalkan",
      cancelFailed: "Gagal membatalkan pesanan",
      cancelModalTitle: "Batalkan pesanan",
      cancelConfirm: "Batalkan pesanan",
      cancelHint:
        "Pesanan akan ditandai sebagai dibatalkan dan pelanggan akan dimaklumkan. Uruskan bayaran balik secara berasingan di Bayaran Balik.",
      cancelReason: "Sebab (direkodkan)",
      cancelReasonPlaceholder:
        "cth. pesanan pendua, permintaan pelanggan, stok habis…",
      cancelOrderAction: "Batalkan pesanan",
      filterAll: "Semua",
      listHeading: "Pesanan",
      liveFeedActive: "Suapan langsung: {{count}} pesanan aktif",
      filterType: "JENIS:",
      typeDisabledWalkinHint: "Pesanan walk-in sentiasa ambil sendiri — tidak pernah penghantaran",
      colAmount: "Jumlah",
      colOrderTime: "Masa pesanan",
      colAction: "Tindakan",
      menuOverview: "Gambaran keseluruhan",
      menuFullDetails: "Butiran penuh",
      menuCancelOrder: "Batalkan pesanan",
      actionMarkReady: "Tandai siap",
      actionPickedUp: "Telah diambil",
      actionOutForDelivery: "Dalam penghantaran",
      actionDelivered: "Telah dihantar",
      actionMarkAsReady: "Tandai sebagai siap",
      actionMarkDelivered: "Tandai telah dihantar",
      drawerChannelDelivery: "Penghantaran",
      drawerChannelPickup: "Ambil sendiri",
      drawerPaid: "Telah dibayar",
      drawerCancelReason: "Sebab pembatalan",
      drawerUnpaid: "Bayaran belum selesai",
      drawerPaymentFailed: "Bayaran gagal",
      drawerUnpaidBadge: "BELUM BAYAR",
      drawerPaymentFailedBadge: "GAGAL",
      drawerCustomerDetails: "Butiran pelanggan",
      drawerDeliveryTime: "Masa penghantaran",
      drawerRider: "Penunggang",
      drawerLalamoveId: "No. pesanan Lalamove",
      drawerTrack: "Pautan jejak",
      drawerProgress: "Kemajuan penghantaran",
      lmAssigning: "Mencari penunggang",
      lmOnGoing: "Penunggang ke kedai",
      lmPickedUp: "Telah diambil, dalam perjalanan",
      lmCompleted: "Dihantar",
      lmFailed: "Penghantaran gagal",
      drawerPickupTime: "Masa pengambilan",
      drawerOrderItemsCount: "Item pesanan ({{count}})",
      drawerTotalAmount: "Jumlah keseluruhan",
      drawerPaymentMethod: "Kaedah pembayaran",
      drawerPaidBadge: "TELAH DIBAYAR",
      drawerAsap: "SEGERA",
      updateStatusFailed: "Gagal mengemas kini status pesanan",
      statusTabNew: "Baru",
      statusTabPreparing: "Sedang Disediakan",
      statusTabReady: "Siap",
      statusTabOutForDelivery: "Dalam Penghantaran",
      statusTabInTransit: "Dalam Perjalanan",
      statusTabDelivered: "Dihantar",
      statusTabCompleted: "Selesai",
      statusTabCancelled: "Batal",
      filterAllStalls: "Semua gerai",
      discountWithCode: "Diskaun ({{code}})",
      voucherFallback: "BAUCAR",
      sstWithRate: "SST ({{rate}}%)",
    },
    refundDetail: {
      notFound: "Bayaran balik tidak dijumpai.",
      back: "Kembali",
      title: "Butiran bayaran balik",
      status: {
        success: "SELESAI",
        pending: "DIPROSES",
        rejected: "DITOLAK",
        failed: "GAGAL",
      },
      typeFull: "Bayaran balik penuh",
      typePartial: "Bayaran balik separa",
      timelineCreated: "Bayaran balik dicipta",
      timelineProcessing: "Sedang diproses",
      timelineCompleted: "Bayaran balik selesai",
      timelineRejected: "Bayaran balik ditolak",
      timelineFailed: "Bayaran balik gerbang gagal",
      staffSystem: "Sistem",
      staffAdmin: "Admin",
      staffGateway: "Gerbang Fiuu",
      gatewayFailureTitle: "Bayaran balik gerbang gagal",
      autoRefundBadge: "Dibayar balik automatik melalui Fiuu",
      gatewayRefundIdLabel: "ID bayaran balik gerbang",
      refundIdLabel: "ID Bayaran Balik",
      refundAmount: "Jumlah bayaran balik",
      amountReclaimedLabel: "Jumlah dituntut semula",
      refundType: "Jenis bayaran balik",
      createdTime: "Masa dicipta",
      requestSource: "Sumber permintaan",
      requestSourcePos: "Terminal POS",
      customerInfo: "Maklumat pelanggan",
      guest: "Tetamu",
      noCustomer: "Tiada maklumat pelanggan",
      phone: "Telefon",
      email: "E-mel",
      transactionInfo: "Maklumat transaksi",
      viewTransaction: "Lihat transaksi →",
      transactionId: "ID Transaksi",
      orderId: "ID Pesanan",
      paymentMethod: "Kaedah pembayaran",
      totalPaid: "Jumlah dibayar",
      refundReason: "Sebab bayaran balik",
      internalNote: "Nota dalaman",
      transferDetails: "Butiran pemindahan",
      method: "Kaedah",
      time: "Masa",
      merchantNoteUpper: "NOTA PENIAGA",
      processTimeline: "Garis masa proses",
      dash: "—",
    },
    orderDetail: {
      invalidId: "ID pesanan tidak sah.",
      notFound: "Pesanan tidak dijumpai.",
      back: "Kembali",
      statusMessageLabel: "Mesej status",
      orderPrefix: "Pesanan",
      paid: "Telah dibayar",
      asap: "SEGERA",
      customer: "Pelanggan",
      customerShortId: "CUST-{{id}}",
      pickupTime: "Masa pengambilan",
      customerWillArrive: "Pelanggan akan tiba untuk mengambil",
      cancelledTime: "Masa pesanan dibatalkan",
      orderCancelledAt: "Pesanan telah dibatalkan",
      deliveryAddress: "Alamat penghantaran",
      rider: "Penunggang",
      riderCancelled: "Pesanan dibatalkan — tiada penghantaran",
      riderDelivered: "Dihantar",
      findingRider: "Mencari penunggang...",
      deliveryFailed: "Penghantaran gagal — memerlukan tindakan manual",
      resubmitLalamove: "Hantar semula ke Lalamove",
      resubmitLalamoveTitle: "Hantar semula ke Lalamove",
      resubmitLalamoveDesc: "Ini akan meminta sebut harga Lalamove baharu dan menghantar penunggang baharu untuk pesanan ini.",
      resubmitLalamoveConfirm: "Hantar semula",
      resubmitLalamoveSuccess: "Dihantar semula ke Lalamove — penghantaran penunggang baharu diminta",
      resubmitLalamoveFailed: "Gagal menghantar semula ke Lalamove",
      pickupTimeRider: "Gerai selesai menyediakan pada",
      riderWillArrive: "Makanan sudah siap, menunggu penunggang mengambil",
      riderHeadingToShop: "Penunggang sedang menuju ke restoran untuk mengambil",
      etaArrive: "Dijangka tiba sekitar {{time}} (anggaran)",
      distanceNotRecorded: "Jarak: tidak direkodkan (kedai tiada koordinat semasa pesanan)",
    riderPlate: "Plat",
      deliveredAtLabel: "Dihantar pada",
      deliveredNote: "Pesanan telah dihantar",
      deliverConfirmTitle: "Tandakan sebagai dihantar?",
      deliverConfirmDesc: "Selepas dihantar, pesanan tidak boleh dibatalkan.",
      deliverForcePrompt: "Penunggang belum mengambil pesanan. Jika benar-benar dihantar, masukkan sebab (min. 3 aksara):",
      trackRider: "Jejak penunggang →",
      specialNote: "Nota khas",
      rating: "Penilaian pelanggan",
      orderItems: "Item pesanan",
      itemsTotal: "Jumlah {{count}} item",
      basePriceMarkup: "Harga asas RM {{base}} + markup RM {{markup}}",
      addonCostMarkup: "Tambahan RM {{cost}} + markup tambahan RM {{markup}}",
      stallPrefix: "Gerai",
      basePriceTotal: "Jumlah harga asas",
      markupTotal: "Jumlah markup",
      addonCostTotal: "Jumlah kos tambahan",
      addonMarkupTotal: "Jumlah markup tambahan",
      subtotal: "Subjumlah",
      discount: "Diskaun",
      deliveryFee: "Yuran penghantaran",
      sstPercent: "SST ({{rate}}%)",
      sstIncludedRow: "SST (termasuk dalam harga)",
      total: "JUMLAH",
      customerPaidAmount: "Jumlah dibayar pelanggan",
      refundHistory: "Sejarah bayaran balik",
      noRefunds: "Tiada sejarah bayaran balik untuk pesanan ini.",
      createRefund: "Cipta bayaran balik",
      transactionDetails: "Butiran transaksi",
      method: "Kaedah",
      status: "Status",
      paidUpper: "TELAH DIBAYAR",
      transactionId: "ID Transaksi",
      viewTransaction: "Lihat transaksi",
      noTxnRecord: "Tiada rekod transaksi",
      orderJourney: "Perjalanan pesanan",
      cancelOrder: "Batalkan pesanan",
      printReceipt: "Cetak resit",
      markAsReady: "Tandai sebagai siap",
      pickedUp: "Telah diambil",
      outForDelivery: "Dalam penghantaran",
      markDelivered: "Tandai telah dihantar",
      cancelModalTitle: "Batalkan pesanan",
      cancelOk: "Batalkan pesanan",
      reasonLabel: "Sebab pembatalan",
      reasonPlaceholder: "cth. Pelanggan meminta pembatalan",
      reasonRequired: "Sila masukkan sebab (minimum 3 aksara)",
      statusUpdated: "Status pesanan dikemas kini",
      updateStatusFailed: "Gagal mengemas kini status",
      cancelSuccess: "Pesanan dibatalkan",
      cancelFailed: "Gagal membatalkan pesanan",
      refundFormTitle: "Borang bayaran balik",
      refundOrderSummary: "Ringkasan pembayaran",
      refundPaidAmount: "Jumlah dibayar",
      refundMaxAmount: "Maksimum boleh dibayar balik: RM {{amount}}",
      refundType: "Jenis bayaran balik",
      refundAmount: "Jumlah bayaran balik",
      refundMethod: "Kaedah bayaran balik",
      refundReason: "Sebab bayaran balik",
      refundReasonPlaceholder: "cth. Pesanan POS dibatalkan selepas pembayaran",
      submitRefund: "Hantar bayaran balik",
      refundCreated: "Permintaan bayaran balik dicipta",
      refundCreateFailed: "Gagal mencipta bayaran balik",
      refundNoPaidTxn: "Pesanan ini tiada transaksi pembayaran yang berjaya.",
      refundNoPaymentTitle: "Pembayaran belum selesai",
      refundNoPaymentDesc: "Bayaran balik hanya boleh dicipta selepas pelanggan berjaya membayar.",
      refundAmountInvalid: "Sila masukkan jumlah bayaran balik yang sah.",
      refundReasonRequired: "Sila masukkan sebab bayaran balik.",
      payment: {
        visa: "Visa/Mastercard",
        fpx: "Perbankan Dalam Talian FPX",
        grabpay: "GrabPay",
        cash: "Tunai",
        ewallet: "eWallet",
        tng: "Touch 'n Go",
        boost: "Boost",
      },
      statusMsg: {
        new: "Menunggu gerai menerima pesanan ini",
        preparing: "Gerai sedang menyediakan pesanan",
        readyPickup: "Pesanan sudah siap — menunggu pelanggan mengambil",
        readyDelivery: "Pesanan sudah siap — menunggu penugasan penunggang",
        outForDelivery: "Penunggang dalam perjalanan untuk mengambil",
        pickedUp: "Penunggang telah mengambil makanan dan sedang dalam perjalanan",
        deliveryIssue: "Penghantaran menghadapi masalah — lihat status penunggang di bawah",
        inTransit: "Pesanan sedang dalam penghantaran",
        delivered: "Pesanan telah dihantar kepada pelanggan",
        completedPickup: "Pesanan telah diambil oleh pelanggan",
        completedDelivery: "Pesanan selesai",
        cancelled: "Pesanan dibatalkan",
      },
      journey: {
        orderCreated: "Pesanan dicipta",
        accepted: "Diterima",
        preparing: "Sedang disediakan",
        ready: "Siap",
        waitingPickup: "Menunggu pengambilan",
        riderAssigned: "Penunggang ditugaskan",
        riderArrived: "Penunggang telah tiba",
        outForDelivery: "Dalam penghantaran",
        delivered: "Telah dihantar",
        pickedUp: "Telah diambil",
        cancelledBy: "Pesanan dibatalkan oleh {{name}}",
        unknownCanceller: "kakitangan",
      },
      journeyCurrent: "(Semasa)",
      journeyPending: "Belum selesai",
      journeyTimeCurrent: "{{time}} (Semasa)",
      refundRowStatus: {
        success: "Berjaya",
        pending: "Tertangguh",
        failed: "Gagal",
      },
      txnPending: "Tertangguh",
    },
    transactionDetail: {
      notFound: "Transaksi tidak dijumpai.",
      breadcrumb: "Butiran transaksi",
      totalAmount: "Jumlah keseluruhan",
      paymentMethod: "Kaedah pembayaran",
      colProvider: "PENYEDIA",
      colReferenceId: "ID RUJUKAN",
      colAuthorization: "KEBENARAN",
      merchantReference: "Rujukan peniaga",
      success: "Berjaya",
      paymentBreakdown: "Pecahan pembayaran",
      subtotal: "Subjumlah",
      deliveryFee: "Yuran penghantaran",
      taxSst: "Cukai (SST {{rate}}%)",
      discount: "Diskaun",
      finalPaidAmount: "Jumlah akhir dibayar",
      partialRefundIssued: "Bayaran balik separa dikeluarkan",
      fullRefundIssued: "Bayaran balik penuh dikeluarkan",
      reason: "SEBAB",
      method: "KAEDAH",
      viaPrefix: "Melalui {{method}}",
      merchantInternalNote: "NOTA DALAMAN PENIAGA",
      customerInfo: "Maklumat pelanggan",
      noCustomer: "Tiada maklumat pelanggan",
      viewOrderDetails: "Lihat butiran pesanan →",
      transactionHistory: "Sejarah transaksi",
      issueRefund: "Keluarkan bayaran balik",
      downloadReceipt: "Muat turun resit",
      orderIdLabel: "ID Pesanan",
      statusPaid: "TELAH DIBAYAR",
      statusPartialRefund: "BAYARAN BALIK SEPARA",
      statusRefunded: "DIBAYAR BALIK",
      statusRefundPending: "BAYARAN BALIK DIPROSES",
      statusPending: "TERTANGGUH",
      statusFailed: "GAGAL",
      timelinePaid: "Pembayaran selesai (berjaya)",
      timelineInitiated: "Pembayaran dimulakan",
      timelineRefundInitiated: "Bayaran balik dimulakan",
      timelineRefundApproved: "Bayaran balik diluluskan",
      timelineRefundRejected: "Bayaran balik ditolak",
      timelineOrderCancelled: "Pesanan dibatalkan oleh admin",
      refundMetaDesc: "Jenis: {{type}}, Jumlah: RM {{amount}}, Kaedah: {{method}}",
      refundTypePartial: "separa",
      refundTypeFull: "penuh",
      timelineNote: "Nota",
      timelineTransferTime: "Masa pemindahan",
      timelineTransferMethod: "Kaedah pemindahan",
      checkoutBy: "Checkout oleh {{name}}",
      authCode: "Kod Kebenaran: {{reference}}",
      authSuccess: "Berjaya",
    },
    staff: {
      stallRequired: "Gerai mesti ditetapkan untuk akaun staf gerai",
      noSessions: "Tiada sesi log masuk dalam tempoh ini",
      lastLoginToday: "Hari ini, {{time}}",
      lastLoginYesterday: "Semalam",
      lastLoginDaysAgo: "{{count}} hari lalu",
      none: "—",
      historyDate: "TARIKH",
      historyTablet: "TABLET",
      historyLogin: "LOG MASUK",
      historyLogout: "LOG KELUAR",
      historyDuration: "TEMPOH",
      historyStatus: "STATUS",
      online: "DALAM TALIAN",
      completed: "SELESAI",
      totalSessions: "JUMLAH SESI",
      avgDuration: "PURATA TEMPOH",
      dailyAverage: "Purata harian",
      lastSeen: "KALI TERAKHIR DILIHAT",
      exportCsv: "Eksport CSV",
      close: "Tutup",
      loginHistoryTitle: "Sejarah log masuk",
      roleAdmin: "ADMIN",
      roleStaffLabel: "KAKITANGAN",
      saveChanges: "Simpan perubahan",
      saveStaff: "Simpan kakitangan →",
      editStaff: "Edit kakitangan",
      addStaff: "Tambah kakitangan",
      personalInfo: "MAKLUMAT PERIBADI",
      fullName: "NAMA PENUH",
      placeholderFullName: "cth. Wei Kang",
      placeholderPhone: "+60 12–345 6789",
      fullNameRequired: "Nama penuh diperlukan",
      phoneNumber: "NOMBOR TELEFON",
      phoneInvalid: "Masukkan nombor telefon Malaysia yang sah, cth. 0123456789",
      phoneInUse: "Nombor telefon ini sudah digunakan",
      emailInUse: "E-mel ini sudah digunakan",
      phoneRequired: "Nombor telefon diperlukan",
      roleAccess: "PERANAN & AKSES",
      admin: "Admin",
      staff: "Kakitangan",
      posOperator: "Operator POS",
      roleInfoAdmin: "Boleh mengakses semua fungsi termasuk laporan, menu dan pengurusan kakitangan.",
      roleInfoStall: "Log masuk ke apl gerai — hanya melihat dan mengurus pesanan untuk baris gilir dapur gerai yang ditugaskan.",
      roleInfoPos: "Log masuk ke apl POS untuk merekod jualan walk-in dan mengurus pesanan. Biarkan gerai tidak ditetapkan untuk terminal kaunter hadapan semua-gerai, atau tetapkan satu gerai untuk mengehadkan log masuk ini kepada pesanan gerai tersebut sahaja.",
      assignedTablet: "TABLET DITETAPKAN",
      assignedStallPos: "GERAI DITETAPKAN (PILIHAN)",
      notAssigned: "Belum ditetapkan",
      notAssignedAllStalls: "Belum ditetapkan (melihat semua gerai)",
      loginPin: "PIN LOG MASUK",
      setupPin: "TETAPKAN PIN",
      confirmPin: "SAHKAN PIN",
      pinRequired: "PIN diperlukan",
      pinLen: "PIN mesti tepat 4 digit",
      pinNumeric: "PIN mesti nombor",
      confirmPinRequired: "Sila sahkan PIN",
      pinMismatch: "PIN tidak sepadan",
      pinHint: "Kakitangan akan menggunakan PIN ini untuk log masuk pada tablet. Pastikan ia unik dan sulit.",
      updatedOk: "Kakitangan berjaya dikemas kini",
      addedOk: "Kakitangan berjaya ditambah",
      saveFailed: "Gagal menyimpan kakitangan. Sila cuba lagi.",
      cancel: "Batal",
      resetPinTitle: "Set semula PIN",
      resetPinBtn: "Set semula PIN →",
      newPinSection: "PIN BAHARU",
      newPin: "PIN BAHARU",
      pinResetOk: "PIN berjaya diset semula",
      pinResetFailed: "Gagal menetapkan semula PIN",
      resetPinHint: "PIN baharu akan berkuat kuasa serta-merta. Kakitangan perlu menggunakannya pada log masuk seterusnya.",
      pinLenReset: "PIN mesti 4 digit",
      numericOnly: "Nombor sahaja",
      managementTitle: "Pengurusan kakitangan",
      pageSubtitle: "Urus kakitangan operasi, tugasan dan akses log masuk.",
      addStaffBtn: "Tambah kakitangan",
      periodToday: "Hari ini",
      periodWeek: "Minggu ini",
      periodMonth: "Bulan ini",
      totalStaff: "JUMLAH KAKITANGAN",
      teamMembers: "Ahli pasukan",
      active: "AKTIF",
      currentlyWorking: "Sedang bekerja",
      inactive: "TIDAK AKTIF",
      offDuty: "Tidak bertugas",
      searchPlaceholder: "Cari nama atau telefon…",
      allRoles: "Semua peranan",
      allStatus: "Semua status",
      activeStatus: "Aktif",
      inactiveStatus: "Tidak aktif",
      colStaffDetails: "BUTIRAN KAKITANGAN",
      colRole: "PERANAN",
      colAssignedTablet: "TABLET DITETAPKAN",
      colStatus: "STATUS",
      colLastLogin: "LOG MASUK TERAKHIR",
      colActions: "TINDAKAN",
      notAssignedTablet: "Belum ditetapkan",
      statusActive: "● Aktif",
      statusInactive: "● Tidak aktif",
      edit: "Edit",
      loginHistory: "Sejarah log masuk",
      resetPassword: "Set semula kata laluan",
      removeStaff: "Buang kakitangan",
      removedOk: "Kakitangan dibuang",
      removeFailed: "Gagal membuang kakitangan",
      showingCount: "Memaparkan {{filtered}} daripada {{total}} kakitangan",
      // Admin Accounts screen (/admins)
      adminAccountsTitle: "Akaun Pentadbir",
      adminAccountsSubtitle: "Urus akaun log masuk dashboard, kebenaran akses dan status",
      adminStatTotal: "Jumlah pentadbir",
      adminStatActive: "Aktif",
      adminStatInactive: "Tidak aktif",
      adminStatBadgeOverall: "Semua akaun",
      adminStatBadgeActive: "Boleh log masuk",
      adminStatBadgeInactive: "Dijeda",
      adminDrawerSubtitleNew: "Konfigurasikan butiran akaun dan ciri yang boleh dicapai",
      adminDrawerSubtitleEdit: "Kemas kini butiran akaun, kata laluan dan kebenaran",
      addAdminBtn: "Tambah Pentadbir",
      editAdmin: "Edit Pentadbir",
      colEmail: "E-mel",
      emailRequired: "E-mel yang sah diperlukan",
      placeholderEmail: "example@kawkaw.my",
      passwordLabel: "Kata Laluan",
      passwordPlaceholderCreate: "Sekurang-kurangnya 8 aksara",
      passwordPlaceholderEdit: "Biarkan kosong untuk kekalkan kata laluan semasa",
      passwordRequired: "Kata laluan diperlukan",
      passwordMinLength: "Kata laluan mestilah sekurang-kurangnya 8 aksara",
      permissionsTitle: "Kebenaran",
      permissionsHint: "Pilih modul yang boleh diakses oleh pentadbir ini.",
      colPermissions: "Kebenaran",
      allPermissions: "Semua kebenaran",
      noPermissions: "Tiada kebenaran",
      morePermissions: "+{{count}} lagi",
      superadminBadge: "Pentadbir Utama",
      superadminLockedHint: "Pentadbir utama mempunyai akses penuh — peranan dan kebenaran tidak boleh diedit.",
      todayWeekMonthToday: "Hari ini",
      todayWeekMonthWeek: "Minggu ini",
      todayWeekMonthMonth: "Bulan ini",
      editTitle: "Edit Kakitangan",
      addTitle: "Tambah Kakitangan",
      colName: "Nama",
      colPhone: "Telefon",
      colStall: "Gerai",
      colCreated: "Dicipta",
      tooltipEdit: "Edit kakitangan",
      tooltipResetPin: "Set semula PIN",
      formInitialPin: "PIN awal (4 digit)",
      formPinLengthMsg: "PIN mesti tepat 4 digit",
      formAssignedStall: "Gerai Ditetapkan (untuk peranan gerai)",
      formNewPin: "PIN baharu",
      formConfirmPin: "Sahkan PIN",
      pinDigitsMsg: "4–6 digit",
      pinResetSuccess: "PIN diset semula — PIN sementara: {{pin}} (kongsi dengan kakitangan)",
      pinResetSuccessSimple: "PIN berjaya diset semula",
      createSuccess: "Kakitangan dicipta",
      updateSuccess: "Kakitangan dikemas kini",
    },
    customers: {
      managementTitle: "Pengurusan Pelanggan",
      pageSubtitle: "Lihat dan urus pelanggan aplikasi — profil, alamat, pesanan dan akses.",
      searchPlaceholder: "Cari nama, telefon atau emel…",
      allStatus: "Semua status",
      activeStatus: "Diaktifkan",
      inactiveStatus: "Dinyahaktifkan",
      colName: "Pelanggan",
      colContact: "Hubungan",
      colStatus: "Status",
      colOrders: "Pesanan",
      colRegistered: "Didaftar",
      colActions: "Tindakan",
      statusActive: "Diaktifkan",
      statusInactive: "Dinyahaktifkan",
      viewDetail: "Lihat butiran",
      detailTitle: "Butiran Pelanggan",
      close: "Tutup",
      profile: "Profil",
      fullName: "Nama",
      email: "Emel",
      phone: "Telefon",
      registeredVia: "Didaftar melalui",
      registeredOn: "Tarikh daftar",
      save: "Simpan",
      saveSuccess: "Pelanggan dikemas kini",
      saveFailed: "Gagal mengemas kini pelanggan",
      accountStatus: "Status akaun",
      enabled: "Diaktifkan",
      disabled: "Dinyahaktifkan",
      enableConfirmTitle: "Aktifkan pelanggan ini?",
      disableConfirmTitle: "Nyahaktifkan pelanggan ini?",
      disableConfirmDesc: "Pelanggan tidak akan dapat log masuk sehingga diaktifkan semula.",
      disableAction: "Nyahaktif",
      statusUpdateSuccess: "Status akaun dikemas kini",
      statusUpdateFailed: "Gagal mengemas kini status akaun",
      addresses: "Alamat",
      noAddresses: "Tiada alamat disimpan",
      defaultAddress: "Lalai",
      recentOrders: "Pesanan Terkini",
      noOrders: "Belum ada pesanan",
      viewAllOrders: "Lihat semua pesanan →",
      resetPassword: "Set Semula Kata Laluan",
      resetPasswordConfirmTitle: "Set semula kata laluan pelanggan ini?",
      resetPasswordConfirmDesc: "Ini akan menjana kata laluan sementara yang boleh terus digunakan pelanggan untuk log masuk — mereka akan diminta menetapkan kata laluan baharu pada log masuk itu.",
      resetPasswordFailed: "Gagal menetapkan semula kata laluan",
      tempPasswordTitle: "Kata laluan sementara dijana",
      tempPasswordDesc: "Berikan kata laluan sementara ini kepada pelanggan: {{password}}\nMereka akan diminta menetapkan kata laluan baharu selepas log masuk. Ini hanya dipaparkan sekali — sila salin sekarang.",
      tempPasswordCopied: "Disalin",
      totalCustomers: "Jumlah Pelanggan",
      enabledCount: "Diaktifkan",
      disabledCount: "Dinyahaktifkan",
    },
    stallApplications: {
      title: "Permohonan Gerai",
      pageSubtitle: "Semak permohonan gerai dan urus keputusan kelulusan",
      statTotal: "Jumlah permohonan",
      statPending: "Menunggu semakan",
      statApproved: "Diluluskan",
      statRejected: "Ditolak",
      statBadgeOverall: "Keseluruhan",
      statBadgePending: "Untuk disemak",
      statBadgeApproved: "Diluluskan",
      statBadgeRejected: "Ditolak",
      colCreatedAt: "Dimohon Pada",
      colStallName: "Nama Gerai",
      colCategory: "Kategori",
      colContact: "Hubungan",
      colStatus: "Status",
      colReviewer: "Pemeriksa",
      colActions: "Tindakan",
      filterStatus: "Tapis mengikut status",
      viewDetail: "Lihat Butiran",
      detailTitle: "Butiran Permohonan",
      labelDescription: "Penerangan",
      labelContactPhone: "Telefon Hubungan",
      labelContactEmail: "E-mel",
      labelReviewNote: "Nota Semakan",
      labelAppliedAt: "Dimohon Pada",
      sortOrderLabel: "Susunan Gerai (lebih rendah = pertama)",
      reviewNoteOptional: "Nota Semakan (pilihan)",
      rejectionPlaceholder: "Sebab penolakan…",
      reviewNotePlaceholder: "Nota pilihan…",
      confirmApprove: "Sahkan Kelulusan",
      confirmReject: "Sahkan Penolakan",
      approveModalTitle: "Luluskan Permohonan",
      rejectModalTitle: "Tolak Permohonan",
      approveDescription: "Meluluskan akan mencipta gerai \"{{name}}\" secara automatik dalam sistem.",
      rejectDescription: "Anda akan menolak permohonan daripada \"{{name}}\".",
      status: {
        pending: "Tertangguh",
        approved: "Diluluskan",
        rejected: "Ditolak",
      },
      approve: "Luluskan",
      reject: "Tolak",
      reviewNote: "Nota Semakan",
      rejectionReason: "Sebab Penolakan (minimum 5 aksara)",
      approvedMsg: "Permohonan diluluskan — gerai telah dicipta!",
      rejectedMsg: "Permohonan ditolak.",
      failedMsg: "Operasi gagal, sila cuba lagi.",
    },
    dashboard: {
      unitsSold: "{{count}} terjual",
      orderFlowTitle: "Aliran pesanan",
      orderFlowSubtitle: "Ringkasan penyediaan, ambil sendiri dan penghantaran",
      todayRevenue: "Hasil Hari Ini",
      todayOrders: "Pesanan Hari Ini",
      pendingRefunds: "Bayaran Balik Tertangguh",
      activeStaff: "Kakitangan Aktif",
      totalRevenue: "Jumlah Hasil",
      totalOrdersToday: "Jumlah Pesanan Hari Ini",
      pickupOrders: "Pesanan Ambil Sendiri",
      deliveryOrders: "Pesanan Penghantaran",
      newNow: "Menunggu terima",
      todayOrdersShort: "Pesanan hari ini",
      preparingNow: "Sedang Disediakan",
      readyForPickup: "Sedia Untuk Diambil",
      readyForDelivery: "Sedia Untuk Dihantar",
      channelDistribution: "Taburan Saluran",
      revenueTrend: "Trend Hasil",
      revenueTrendSub: "Prestasi harian merentas saluran",
      todayTab: "Hari Ini",
      weeklyTab: "Mingguan",
      topSelling: "Item Paling Laris",
      noSalesToday: "Tiada data jualan untuk hari ini",
      recentActivity: "Aktiviti Terkini",
      viewAllHistory: "Lihat semua sejarah",
      colOrderId: "ID Pesanan",
      colChannel: "Saluran",
      colCustomer: "Pelanggan",
      colAmount: "Jumlah",
      colStatus: "Status",
      colTime: "Masa",
      colAction: "Tindakan",
      viewDetails: "Lihat butiran",
      ordersUnit: "pesanan",
      today: "Hari ini",
      fromYesterday: "berbanding semalam",
      current: "Semasa",
      todayLabel: "Hari ini",
      pickup: "Ambil Sendiri",
      delivery: "Penghantaran",
      tooltipRevenue: "Hasil",
      topItemOrders: "{{count}} pesanan",
      topItemPeriodToday: "Hari ini",
      topItemPeriodAll: "Semua data",
      donutPickupShare: "AMBIL SENDIRI",
      avgOrderValue: "Purata Nilai Pesanan",
      pickupShare: "Bahagian Ambil Sendiri",
      deliveryShare: "Bahagian Penghantaran",
      revenueMovement: "Pergerakan Hasil",
      revenueUp: "Naik",
      revenueDown: "Turun",
    },
    menu: {
      title: "Pengurusan Menu",
      addItem: "Tambah Item",
      editTitle: "Edit Item Menu",
      addTitle: "Tambah Item Menu",
      selectStallPrompt: "Pilih gerai untuk melihat item menu",
      colImage: "Gambar",
      colName: "Nama",
      colCategory: "Kategori",
      colPrice: "Harga",
      colAvailable: "Tersedia",
      colStock: "Stok",
      formImage: "Gambar",
      formName: "Nama",
      formDescription: "Penerangan",
      formCategory: "Kategori",
      formPrice: "Harga (RM)",
      formDailyStock: "Had Stok Harian (kosongkan = tiada had)",
      formDailyStockPlaceholder: "cth. 50",
      formAvailableFrom: "Tersedia Dari (HH:MM)",
      formAvailableTo: "Tersedia Hingga (HH:MM)",
      formTimeAvailableFromPh: "07:00",
      formTimeAvailableToPh: "22:00",
      formOfferPricePlaceholder: "cth. 4.50",
      formTimeOfferFromPh: "10:00",
      formTimeOfferToPh: "14:00",
      formIsAvailable: "Tersedia",
      formSortOrder: "Susunan",
      formOfferPrice: "Harga Promosi (RM) (kosongkan = tiada promosi)",
      formOfferFrom: "Promosi Dari (HH:MM)",
      formOfferTo: "Promosi Hingga (HH:MM)",
      createSuccess: "Item dicipta",
      updateSuccess: "Item dikemas kini",
      deleteSuccess: "Item dipadam",
      saveFailed: "Simpan gagal",
      deleteFailed: "Padam gagal",
      manageOptions: "Pilihan",
      categoryOptionGroups: "Kumpulan pilihan lalai",
      categoryOptionGroupsTooltip: "Item baharu dalam kategori ini mewarisi kumpulan pilihan ini, seperti tahap gula, ais atau kepedasan. Anda boleh menamakan semula, menambah atau membuangnya.",
      categoryOptionGroupsEmpty: "Belum ada kumpulan pilihan lalai",
      categoryOptionGroupNamePlaceholder: "Nama kumpulan, cth. Tahap pedas",
      categoryOptionChoicePlaceholder: "cth. Kurang pedas",
      categoryAddOptionGroup: "Tambah kumpulan pilihan",
      optionsDrawerTitle: "Kumpulan Pilihan — {{name}}",
      addGroup: "Tambah Kumpulan Pilihan",
      editGroup: "Edit Kumpulan Pilihan",
      groupName: "Nama Kumpulan",
      groupType: "Jenis",
      groupTypeRequired: "Wajib",
      groupTypeOptional: "Pilihan",
      groupMinSelect: "Pilih Minimum",
      groupMaxSelect: "Pilih Maksimum",
      addChoice: "Tambah Pilihan",
      editChoice: "Edit Pilihan",
      choiceLabel: "Label Pilihan",
      choiceExtraCharge: "Caj Tambahan (RM)",
      groupSaved: "Kumpulan disimpan",
      groupDeleted: "Kumpulan dipadam",
      choiceSaved: "Pilihan disimpan",
      choiceDeleted: "Pilihan dipadam",
      confirmDeleteGroup: "Padam kumpulan pilihan ini?",
      confirmDeleteChoice: "Padam pilihan ini?",
      formGroupIcon: "Ikon",
      groupIconSugar: "Tahap gula",
      groupIconIce: "Tahap ais",
      groupIconSpecial: "Permintaan khas",
      choiceInputType: "Jenis",
      choiceTypeRadio: "Radio",
      choiceTypeInputBox: "Kotak input",
      choiceTypeTextarea: "Kotak teks",
      choiceTypeQuantity: "Tambahan kuantiti",
      choiceTypeHelp: "Jenis: Radio = pilih (caj tambahan pilihan); Tambahan kuantiti = tambahan berbayar dengan butang − + (cth. Ham RM1.50); Kotak input / Kotak teks = nota teks pelanggan, tiada kuantiti.",
      choicePlaceholderLabel: "Teks pemegang tempat",
      choicePlaceholderExample: "cth. Sebarang permintaan khas?",
      yourStalls: "Gerai Anda",
      stallBadgeActive: "AKTIF",
      stallBadgePaused: "DIJEDA",
      selectStallFromLeft: "Pilih gerai untuk mengurus menunya.",
      managingSummary: "{{items}} · {{categories}}",
      itemCount_one: "{{count}} item",
      itemCount_other: "{{count}} item",
      categoryCount_one: "{{count}} kategori",
      categoryCount_other: "{{count}} kategori",
      colHeaderItemName: "NAMA ITEM",
      colHeaderCategory: "KATEGORI",
      sortTitle: "Seret untuk susun", listView: "Senarai", sortView: "Susun semula", searchPlaceholder: "Cari nama item", allCategories: "Semua kategori", uncategorized: "Tiada kategori", sortHint: "Tahan ⠿ dan seret untuk susun; disimpan apabila dilepas. Menu pelanggan mengikut susunan ini (item disemat sentiasa di atas).", sortFilteredHint: "Hanya item yang ditapis dipaparkan; susunan hanya mengubah kedudukan relatif antara mereka.", sortSaved: "Susunan disimpan", sortFailed: "Gagal menyimpan susunan", sortEmpty: "Tiada item sepadan", sortPinned: "Disemat", sortUnavailable: "Tidak tersedia", sortTop: "Alih ke atas sekali", sortUp: "Naik", sortDown: "Turun", noMatch: "Tiada item sepadan",
      colHeaderPriceRm: "HARGA (RM)",
      colHeaderAvailability: "KETERSEDIAAN",
      colHeaderLastUpdated: "KEMASKINI TERAKHIR",
      stallPanelTitle: "Butiran Gerai",
      stallIdLabel: "ID Gerai: #{{id}}",
      stallStatusTitle: "Status Gerai",
      stallOnline: "DALAM TALIAN",
      stallOffline: "LUAR TALIAN",
      pauseOrdersHint: "Jeda pesanan buat sementara waktu",
      prepTimeSection: "Masa Penyediaan",
      prepTimeMins: "minit",
      autoAcceptTitle: "Terima Pesanan Automatik",
      autoAcceptHint: "Disyorkan untuk trafik tinggi",
      manageCategories: "Kategori",
      categoriesDrawerTitle: "Kategori — {{stall}}",
      addCategory: "Tambah Kategori",
      editCategory: "Sunting Kategori",
      categoriesEmptyTitle: "Belum ada kategori",
      categoriesEmptyHint: "Pilih Tambah Kategori untuk menyusun menu gerai ini.",
      categoryName: "Nama Kategori",
      categorySortOrder: "Susunan",
      categoryCreateSuccess: "Kategori dicipta",
      categoryUpdateSuccess: "Kategori dikemas kini",
      categoryDeleteSuccess: "Kategori dipadam",
      formCategoryId: "Kategori",
      formCategoryPlaceholder: "Pilih kategori (pilihan)",
      formCategoryEmoji: "Emoji",
      formCategoryName: "Nama kategori",
      categoryEmoji: "Emoji",
      globalCategory: "Global",
      categoryEmojiHint: "Tampal satu emoji (cth. ☕). Jika ikon dimuat naik, ia diutamakan",
      categoryIcon: "Ikon / Imej",
      categoryIconHint: "Muat naik ikon atau imej tersuai (dipaparkan menggantikan emoji)",
      formCategoryEmojiPlaceholder: "cth. ☕",
      categoryStallOptional: "Pilihan — kosongkan untuk kategori global",
      categorySugarChoices: "Pilihan tahap gula",
      categorySugarChoicesTooltip:
        "Jika ditetapkan, item dalam kategori ini akan menggunakan pilihan gula ini; biarkan kosong untuk lalai apl.",
      categorySugarChoicesEmpty: "Menggunakan lalai apl",
      categorySugarChoicesPlaceholder: "cth. 25% Kurang Manis",
      categoryIceChoices: "Pilihan tahap ais",
      categoryIceChoicesTooltip:
        "Jika ditetapkan, item dalam kategori ini akan menggunakan pilihan ais ini; biarkan kosong untuk lalai apl.",
      categoryIceChoicesEmpty: "Menggunakan lalai apl",
      categoryIceChoicesPlaceholder: "cth. Kurang Ais",
    },
    transactions: {
      title: "Transaksi",
      searchPlaceholder: "Cari rujukan",
      filterStatus: "Status",
      statusSuccess: "Berjaya",
      statusPending: "Tertangguh",
      statusRefunded: "Dibayar Balik",
      statusFailed: "Gagal",
      refundBtn: "Bayaran Balik",
      refundModalTitle: "Bayaran Balik",
      refundOriginal: "Asal:",
      refundPaidVia: "dibayar melalui",
      refundType: "Jenis Bayaran Balik",
      refundTypeFull: "Bayaran balik penuh",
      refundTypePartial: "Bayaran balik separa",
      refundAmount: "Jumlah Bayaran Balik (RM)",
      refundMethod: "Kaedah Bayaran Balik",
      refundReason: "Sebab",
      refundReasonPlaceholder: "Sebab bayaran balik…",
      submitRefund: "Hantar Bayaran Balik",
      refundInitiated: "Bayaran balik dimulakan — menunggu semakan",
      refundFailed: "Gagal memulakan bayaran balik",
      pageTitle: "Transaksi",
      statTotalTxns: "JUMLAH TRANSAKSI",
      statTotalRevenue: "JUMLAH DITERIMA (RM)",
      statTotalRevenueHint: "Jumlah diterima daripada transaksi berjaya. Berbeza daripada jumlah pesanan di Laporan, yang termasuk pesanan belum bayar dan tidak termasuk yang dibatalkan.",
      statTotalRefunded: "JUMLAH DIBAYAR BALIK (RM)",
      statNetRevenue: "HASIL BERSIH (RM)",
      searchPlaceholderWide: "Cari mengikut ID, Pelanggan atau ID Pesanan…",
      datePreset7d: "7 Hari Lepas",
      datePreset30d: "30 Hari Lepas",
      datePreset90d: "90 Hari Lepas",
      datePresetAll: "Sepanjang Masa",
      filterAllPaymentMethods: "Semua Kaedah Pembayaran",
      filterAllStatus: "Semua Status",
      filterAllOrderTypes: "Semua Jenis Pesanan",
      filterAllSources: "Semua Sumber",
      sourceWalkin: "Walk-in (POS)",
      sourceCustomerApp: "Apl pelanggan",
      statusPartialRefund: "Bayaran Balik Separa",
      colTxnId: "ID Transaksi",
      colCustomerOrder: "Pelanggan / Pesanan",
      customerLabel: "Pelanggan",
      colOrderType: "Jenis Pesanan",
      colAmount: "Jumlah",
      colPayment: "Pembayaran",
      colStatus: "Status",
      colDateTime: "Tarikh & Masa",
      actionViewDetails: "LIHAT BUTIRAN",
      actionRefunds: "BAYARAN BALIK",
      actionReceipt: "RESIT",
      partialRefNote: "Ruj",
      testFailedGeneric: "Ujian gagal",
    },
    refunds: {
      title: "Bayaran Balik",
      pageHeading: "Bayaran Balik",
      colId: "ID",
      colAmount: "Jumlah",
      colReason: "Sebab",
      colPaymentRef: "Ruj. Pembayaran",
      colStatus: "Status",
      colRequested: "Diminta",
      colActions: "Tindakan",
      colRefundId: "ID Bayaran Balik",
      colTxnId: "ID Transaksi",
      colCustomerOrder: "Pelanggan / pesanan",
      colType: "Jenis",
      colAction: "Tindakan",
      filterStatus: "Tapis status",
      statusPendingReview: "Menunggu Semakan",
      statusApproved: "Diluluskan",
      statusRejected: "Ditolak",
      approve: "Luluskan",
      reject: "Tolak",
      approveTitle: "Luluskan Bayaran Balik",
      rejectTitle: "Tolak Bayaran Balik",
      noteLabel: "Nota Dalaman (pilihan)",
      notePlaceholder: "Tambah nota untuk jejak audit…",
      approvedMsg: "Bayaran balik diluluskan",
      rejectedMsg: "Bayaran balik ditolak",
      reviewFailed: "Gagal memproses semakan",
      statTotalAmount: "Jumlah dibayar balik (berjaya sahaja)",
      statTotalCount: "Bilangan dibayar balik (berjaya sahaja)",
      statPartialCount: "Bayaran balik separa (berjaya sahaja)",
      statTodayAmount: "Dibayar balik hari ini (berjaya sahaja)",
      statSubVsLastMonth: "{{pct}} berbanding bulan lepas",
      statSubNoLastMonth: "Tiada bayaran balik bulan lepas",
      statAccumulatedMonth: "Bulan ini · belum diproses tidak dikira",
      statPartialPct: "{{pct}}% daripada jumlah volum",
      statUpdatedNow: "Dikemas kini sebentar tadi",
      dateRange: "Julat tarikh",
      refundType: "Jenis bayaran balik",
      paymentMethod: "Kaedah pembayaran",
      status: "Status",
      quickSearch: "Carian pantas",
      placeholderAllTypes: "Semua jenis",
      placeholderAllMethods: "Semua kaedah",
      placeholderAllStatus: "Semua status",
      placeholderSearch: "ID TXN / nama",
      typeFull: "Bayaran balik penuh",
      typePartial: "Bayaran balik separa",
      statusPending: "Tertangguh",
      statusSuccess: "Berjaya",
      statusRejectedPill: "Ditolak",
      statusFailed: "Gagal",
      typeFullRef: "REF PENUH",
      typePartialRef: "REF SEPARA",
      pillSuccess: "BERJAYA",
      pillPending: "TERTANGGUH",
      pillRejected: "DITOLAK",
      pillFailed: "GAGAL",
      recentRecords: "Rekod bayaran balik terkini",
      exportCsv: "Eksport CSV",
      exportPdf: "Eksport PDF",
      menuUpdateStatus: "Kemas kini status",
      menuViewDetails: "Lihat butiran",
      menuViewOrders: "Lihat pesanan",
      statusUpdated: "Status bayaran balik dikemas kini",
      statusUpdateFailed: "Gagal mengemas kini status bayaran balik",
      modalTitle: "Kemas kini status bayaran balik",
      modalRefundId: "ID Bayaran Balik:",
      summaryTitle: "Ringkasan bayaran balik",
      customer: "Pelanggan",
      orderId: "ID Pesanan",
      transactionId: "ID Transaksi",
      refundAmount: "Jumlah bayaran balik",
      currentStatus: "Status semasa:",
      updateStatus: "Kemas kini status",
      optCompleted: "SELESAI",
      optRejected: "DITOLAK",
      transferDetails: "Butiran pemindahan",
      transferMethod: "Kaedah pemindahan",
      transferMethodRequired: "Pilih cara bayaran balik",
      transferTime: "Masa pemindahan",
      referenceNote: "Nota rujukan",
      rejectionReason: "Sebab penolakan",
      placeholderTransferMethod: "Pilih kaedah",
      placeholderTransferTime: "MM/DD/YYYY, HH:MM AM/PM",
      placeholderReference: "cth. Resit Maybank #8812",
      placeholderRejection: "Sebab penolakan…",
      transferEwallet: "E-dompet",
      transferBank: "Pemindahan bank",
      transferCash: "Tunai",
      transferFpx: "FPX",
      transferCard: "Visa/kad",
      warnConfirmTransfer: "Sahkan bayaran balik telah berjaya dipindahkan. Tindakan ini tidak boleh dibatalkan.",
      cancel: "Batal",
      confirmUpdate: "Sahkan kemas kini",
      payVisa: "Visa / kad",
      payFpx: "FPX",
      payGrab: "GrabPay",
      payCash: "Tunai",
      payEwallet: "E-dompet",
      payTng: "Touch 'n Go",
      payBoost: "Boost",
      autoRefundTitle: "Bayaran balik automatik melalui Fiuu",
      autoRefundDesc: "Bayaran balik ini akan diproses secara automatik melalui Fiuu, terus ke kaedah pembayaran asal pelanggan. Tidak perlu butiran pemindahan manual.",
      warnConfirmAutoRefund: "Ini akan mencetuskan permintaan bayaran balik sebenar ke Fiuu. Tindakan ini tidak boleh dibatalkan.",
      autoRefundSuccessToast: "Bayaran balik diproses secara automatik — wang dikembalikan melalui Fiuu",
      autoRefundPendingToast: "Bayaran balik dihantar ke Fiuu — masih diproses, semak semula sebentar lagi",
      autoRefundFailedToast: "Fiuu menolak bayaran balik{{reason}}",
    },
    vouchers: {
      sectionDistribution: "Pengedaran & Gabungan Baucar",
      lblScope: "Skop baucar",
      scopePlatform: "Platform (mana-mana gerai)",
      scopeMerchant: "Peniaga (satu gerai sahaja)",
      lblDiscountTarget: "Sasaran diskaun",
      targetSubtotal: "Subjumlah item",
      targetDeliveryFee: "Yuran penghantaran",
      lblMerchantStall: "Gerai peniaga",
      merchantStallRequired: "Pilih gerai yang memiliki baucar peniaga ini",
      phMerchantStall: "Pilih gerai",
      lblNoMinimum: "Tanpa minimum (angpau)",
      lblDailyUseCap: "Had penggunaan harian",
      phUnlimited: "Tanpa had",
      stackingHint: "Sehingga 3 baucar boleh digabungkan bagi setiap pesanan: satu baucar peniaga, satu platform dan satu yuran penghantaran — digunakan mengikut urutan ini sebelum SST.",
      title: "Baucar",
      pageSubtitle: "Cipta, pantau dan urus promosi pelanggan",
      newVoucher: "Baucar Baharu",
      editTitle: "Edit Baucar",
      newTitle: "Baucar Baharu",
      colMinSpend: "Perbelanjaan Min.",
      colUses: "Penggunaan",
      colStatus: "Status",
      colValidUntil: "Sah Hingga",
      formCode: "Kod",
      formDiscountType: "Jenis Diskaun",
      formDiscountTypePercentage: "Peratusan %",
      formDiscountTypeFixed: "Amaun Tetap (RM)",
      formDiscountTypeFreeItem: "Item Percuma",
      formDiscountValue: "Nilai Diskaun",
      formMinSpend: "Perbelanjaan Minimum (RM)",
      formUsageLimit: "Had Penggunaan (kosongkan = tiada had)",
      formValidFrom: "Sah Dari",
      formValidUntil: "Sah Hingga",
      formStatus: "Status",
      formStatusActive: "Aktif",
      formStatusScheduled: "Dijadualkan",
      formStatusExpired: "Luput",
      formStatusDisabled: "Dilumpuhkan",
      formStatusInactive: "Tidak aktif",
      formSingleUse: "Sekali Guna Setiap Pelanggan",
      createSuccess: "Baucar dicipta",
      updateSuccess: "Baucar dikemas kini",
      saveFailed: "Simpan gagal",
      deleteConfirm: "Lumpuhkan baucar ini?",
      deleteConfirmDesc: "Ia akan ditandai dilumpuhkan dan tidak boleh digunakan.",
      deleteSuccess: "Baucar dilumpuhkan",
      deleteFailed: "Gagal melumpuhkan baucar",
      pageCreateBtn: "Cipta Baucar",
      statBadgeOverall: "KESELURUHAN",
      statBadgeActive: "AKTIF",
      statBadgeInactive: "TIDAK AKTIF",
      statBadgeGrowth: "JUMLAH",
      statTotalVouchers: "Jumlah Baucar",
      statActive: "Aktif",
      statExpired: "Luput",
      statTotalRedeemed: "Jumlah Ditebus",
      searchPlaceholder: "Cari mengikut kod atau nama…",
      filterAllStatus: "Semua Status",
      filterAllTypes: "Semua Jenis",
      colCode: "KOD",
      colVoucherName: "NAMA BAUCAR",
      colType: "JENIS",
      colValue: "NILAI",
      colMinOrder: "PESANAN MIN",
      colUsage: "PENGGUNAAN",
      colValidPeriod: "TEMPOH SAH",
      colStatusHeader: "STATUS",
      colActions: "TINDAKAN",
      ongoing: "Berterusan",
      menuEdit: "Edit",
      menuUsage: "Lihat penggunaan",
      menuDistribute: "Edar kepada pelanggan",
      menuDelete: "Padam",
      distributeTitle: "Edar \"{{code}}\" kepada pelanggan",
      sendToWallet: "Hantar ke dompet",
      distributeHint: "Cari melalui nombor telefon atau nama, kemudian pilih pelanggan untuk meletakkan baucar ini terus ke dalam dompet mereka.",
      distributeSearch: "Cari nombor telefon atau nama…",
      distributeSelect: "Pilih pelanggan",
      distributionSuccess: "Baucar dihantar kepada {{count}} pelanggan",
      usageTitle: "Penggunaan — \"{{code}}\"",
      usageEmpty: "Baucar ini belum ditebus pada mana-mana pesanan.",
      usageSlot: "Sumber",
      usageDiscount: "Diskaun",
      slotMerchantPlatform: "Peniaga / Platform",
      slotPlatform: "Platform",
      slotDeliveryFee: "Yuran penghantaran",
      typeTagPercentage: "PERATUSAN",
      typeTagFixed: "AMAUN TETAP",
      typeTagFreeItem: "ITEM PERCUMA",
      drawerSubtitleNew: "Konfigurasikan butiran promosi Anda di bawah",
      btnCancel: "BATAL",
      btnSaveChanges: "SIMPAN PERUBAHAN",
      btnSaveVoucher: "SIMPAN BAUCAR",
      sectionBasic: "Maklumat Asas",
      sectionDiscount: "Tetapan Diskaun",
      sectionUsage: "Had Penggunaan",
        sectionAutoGrant: "Pemberian Automatik",
        lblAutoGrantTrigger: "Beri automatik apabila",
        autoGrantNone: "Manual / tuntutan siaran sahaja",
        autoGrantFirstOrder: "Pelanggan melengkapkan pesanan pertama",
        autoGrantHint: "Apabila ditetapkan, baucar ini ditambah ke dompet pelanggan secara automatik sebaik syarat dipenuhi — tiada tuntutan diperlukan.",
      sectionValidity: "Tempoh Sah",
      sectionApplicable: "Terpakai Untuk",
      lblVoucherName: "Nama Baucar",
      phVoucherName: "cth., Tawaran Kopi Hujung Minggu",
      lblVoucherCode: "Kod Baucar",
      codeRequired: "Kod diperlukan",
      btnAutoGenerate: "JANA AUTOMATIK",
      lblDescription: "Penerangan",
      lblVoucherImage: "Gambar Baucar (lakaran kecil)",
      tabPercentage: "Peratusan",
      tabFixedRm: "RM Tetap",
      tabFreeDelivery: "Penghantaran Percuma",
      tabApplicableAll: "Semua",
      tabApplicablePickup: "Ambil Sendiri",
      tabApplicableDelivery: "Penghantaran",
      lblValuePct: "Nilai (%)",
      lblMaxCapRm: "Had Maksimum (RM)",
      lblDiscountAmountRm: "Amaun Diskaun (RM)",
      freeDeliveryHint: "Yuran penghantaran akan digugurkan sepenuhnya",
      lblMinOrderRm: "Nilai Pesanan Minimum (RM)",
      lblTotalUsageLimit: "Jumlah Had Penggunaan",
      lblPerCustomer: "Setiap Pelanggan",
      lblStartDate: "Tarikh Mula",
      lblEndDate: "Tarikh Tamat",
      enableImmediatelyTitle: "Aktifkan Baucar serta-merta",
      enableImmediatelyHint: "STATUS AKAN MENJADI 'AKTIF' SEBAIK SAHAJA DISIMPAN",
      filterStatusActive: "Aktif",
      filterStatusScheduled: "Dijadualkan",
      filterStatusExpired: "Luput",
      filterStatusDisabled: "Dilumpuhkan",
      filterTypePercentage: "Peratusan",
      filterTypeFixed: "Amaun Tetap",
      filterTypeFreeItem: "Item Percuma",
    },
    bundles: {
      title: "Pek Gabungan",
      pageTitle: "Promosi",
      pageSubtitle: "Cipta, tetapkan harga dan urus promosi pek",
      newBundle: "Pek Baharu",
      createBundle: "Cipta Pek",
      editTitle: "Edit Pek Gabungan",
      newTitle: "Pek Gabungan Baharu",
      colName: "Nama",
      colBundlePrice: "Harga Pek",
      colOriginalPrice: "Asal",
      colFor: "Untuk",
      colValid: "Sah",
      colActive: "Aktif",
      formName: "Nama",
      formDescription: "Penerangan",
      formItemsLabel: "Item (pilih gerai dahulu)",
      formStall: "Gerai",
      formItemsJson: "Item pek (JSON)",
      formOriginalPrice: "Harga Asal (RM)",
      formBundlePrice: "Harga Pek (RM)",
      formApplicableFor: "Terpakai untuk",
      formApplicableBoth: "Kedua-dua",
      formApplicablePickup: "Ambil Sendiri",
      formApplicableDelivery: "Penghantaran",
      formValidityPeriod: "Tempoh sah",
      formIsActive: "Aktif",
      confirmDelete: "Padam pek gabungan ini?",
      deleteTitle: "Padam pek gabungan ini?",
      deleteContent: "Tindakan ini kekal dan tidak boleh dibatalkan.",
      deleteBtn: "Padam",
      createSuccess: "Pek dicipta",
      updateSuccess: "Pek dikemas kini",
      deleteSuccess: "Pek dipadam",
      saveFailed: "Gagal menyimpan pek",
      deleteFailed: "Gagal memadam pek",
      statTotal: "Jumlah pek",
      statActive: "Aktif",
      statDisabled: "Dilumpuhkan",
      statBadgeOverall: "Keseluruhan",
      statBadgeActive: "Aktif",
      statBadgeDisabled: "Tidak aktif",
      searchPlaceholder: "Cari nama pek…",
      statusAll: "Status: Semua",
      statusActiveOnly: "Aktif",
      statusDisabledOnly: "Dilumpuhkan",
      applicableAll: "Terpakai: Semua",
      applicableBoth: "Ambil sendiri & penghantaran",
      applicablePickup: "Ambil sendiri sahaja",
      applicableDelivery: "Penghantaran sahaja",
      tabAll: "Semua",
      tabPickup: "Ambil Sendiri",
      tabDelivery: "Penghantaran",
      loading: "Memuatkan…",
      empty: "Tiada pek dijumpai.",
      drawerSubtitleCreate: "Konfigurasikan butiran pek Anda di bawah",
      cancel: "Batal",
      saveChanges: "Simpan perubahan",
      saveBundle: "Simpan pek",
      sectionBasic: "Maklumat asas",
      bundleName: "Nama pek",
      nameRequired: "Nama pek diperlukan",
      namePlaceholder: "cth. Set sarapan",
      description: "Penerangan",
      sectionItems: "Item dalam pek ini",
      addItem: "Tambah item",
      searchItemPlaceholder: "Cari item mengikut nama atau gerai…",
      noItemsFound: "Tiada item dijumpai",
      noItemsYet: "Belum ada item ditambah",
      originalTotal: "Jumlah asal:",
      sectionBundlePrice: "Harga pek",
      splitCost: "Kos pembahagian (seunit)",
      splitTotal: "Jumlah kos pembahagian",
      platformKeeps: "Platform simpan RM {{amount}}",
      splitOverWarning: "Kos pembahagian melebihi harga pek sebanyak RM {{amount}} — platform akan rugi bagi setiap pek.",
      bundlePriceRm: "Harga pek (RM)",
      originalPrice: "Harga asal",
      bundlePriceRow: "Harga pek",
      customerSaves: "Pelanggan jimat",
      sectionApplicable: "Terpakai untuk",
      setExpiry: "Tetapkan tarikh luput",
      noExpiryHint: "Pek ini tiada tarikh luput.",
      startDate: "Tarikh mula",
      endDate: "Tarikh tamat",
      activeStatus: "Status aktif",
      activeStatusHint: "Lumpuhkan untuk menyembunyikan pek ini tanpa memadamnya.",
      pillActive: "Aktif",
      pillDisabled: "Dilumpuhkan",
      previewAction: "Pratonton",
      unknownStall: "Gerai tidak diketahui",
    },
    settlement: {
      gross: "Kasar (harga senarai)",
      stallFee: "Potongan item (atas harga menu gerai)",
      addonFee: "Potongan tambahan (atas kos tambahan)",
      bundleFee: "Potongan set (atas harga set)",
      bundleShare: "Bahagian diskaun pek",
      cutlery: "termasuk peralatan makan",
      net: "Bersih perlu dibayar",
      deductions: "Potongan",
      orders: "Pesanan",
      stall: "Gerai",
      allStalls: "Semua gerai",
      from: "Dari",
      to: "Hingga",
      byStall: "Mengikut gerai",
      byOrder: "Mengikut pesanan (jumlah dibayar kepada gerai)",
      orderCode: "Pesanan",
      orderTime: "Masa pesanan",
      exportSettlement: "Eksport CSV penyelesaian",
      exportLines: "Eksport CSV baris pesanan",
      exportBundles: "Eksport CSV pek",
      invalidRange: "Tarikh mula tidak boleh selepas tarikh tamat.",
      formulaHint: "Penyata sebelah gerai: Kasar = harga menu gerai + kos tambahan. Potongan item = jumlah tetap jika harga menu sama atau di bawah ambang, jika tidak peratusan; potongan tambahan = peratusan kos tambahan; potongan set = peraturan sama atas harga set. Bersih = kasar − potongan item − tambahan − set − bahagian diskaun set. Markup pelanggan tidak termasuk. Semua angka diambil daripada rekod pesanan; pesanan dibatalkan dan item ditolak dikecualikan.",
    },
    reports: {
      title: "Laporan",
      granularityHourly: "Setiap Jam",
      granularityDaily: "Harian",
      granularityWeekly: "Mingguan",
      granularityMonthly: "Bulanan",
      presetToday: "Hari ini",
      presetLast7: "7 hari lepas",
      presetLast30: "30 hari lepas",
      presetThisMonth: "Bulan ini",
      chartRevenueOrders: "Hasil & Pesanan Mengikut Masa",
      chartNoData: "Tiada data untuk tempoh dipilih",
      chartRevenueByStall: "Hasil Mengikut Gerai",
      chartNoDataShort: "Tiada data",
      tableStallBreakdown: "Pecahan Gerai",
      colStall: "Gerai",
      colRevenue: "Hasil",
      colOrders: "Pesanan",
      colAvgOrder: "Purata Pesanan",
      tableTotal: "Jumlah",
      dataRange: "Data dari {{from}} hingga {{to}}",
      tabFinancial: "Kewangan",
      tabRisk: "Risiko",
      tabStalls: "Jualan mengikut gerai",
      tabStaff: "Aktiviti kakitangan",
      tabPricing: "Pecahan harga",
      tabSettlement: "Penyelesaian gerai",
      colQty: "Kuantiti",
      colBasePriceTotal: "Jumlah harga asas",
      colMarkupTotal: "Markup pelanggan (platform caj pelanggan)",
      colBundleDiscount: "Diskaun set",
      colStallDeduction: "Potongan gerai (platform caj gerai)",
      colPlatformIncome: "Pendapatan platform (markup pelanggan + potongan gerai)",
      colSstIncluded: "SST dalam harga (bukan hasil / pendapatan platform)",
      colOptionsTotal: "Jumlah tambahan",
      colOptionsMarkupTotal: "Markup tambahan pelanggan",
      pricingBreakdownTitle: "Harga asas vs markup — bulanan",
      pricingBreakdownSub: "Jumlah harga asas dan markup setiap gerai, boleh ditapis mengikut gerai dan kategori pesanan (walk-in vs apl pelanggan). Pesanan walk-in sentiasa membawa markup RM0.00.",
      filterMonth: "Bulan",
      filterStall: "Gerai",
      filterAllStalls: "Semua gerai",
      filterCategory: "Kategori pesanan",
      categoryAll: "Semua pesanan",
      categoryWalkin: "Walk-in (POS)",
      categoryCustomerApp: "Apl pelanggan",
      rowGrandTotal: "Jumlah besar",
      periodToday: "Hari ini",
      periodWeek: "Minggu ini",
      periodMonth: "Bulan ini",
      cardTotalRevenue: "Jumlah pesanan (tanpa dibatalkan)",
      cardTotalRefunds: "Jumlah bayaran balik",
      refundTxCount: "{{count}} bayaran balik selesai (permintaan menunggu tidak dikira)",
      cardNetRevenue: "Hasil bersih",
      afterRefunds: "= jumlah pesanan − bayaran balik pada pesanan yang dikira",
      cardTotalRevenueHint: "Jumlah pesanan = jumlah semua pesanan tidak dibatalkan dalam tempoh (termasuk belum bayar). Halaman Transaksi hanya mengira bayaran berjaya, jadi kedua-duanya berbeza.",
      refundsOnCancelled: "{{count}} lagi bayaran balik (RM {{amount}}) milik pesanan dibatalkan dan tidak dikira dalam hasil",
      colCancelledRefunds: "Bayaran balik pesanan dibatalkan",
      cardTotalOrders: "Jumlah pesanan",
      pickupDelivery: "Ambil sendiri & penghantaran",
      revVsLastPeriod: "{{pct}}% berbanding tempoh lepas",
      legendRevenue: "Hasil",
      legendOrders: "Pesanan",
      salesTrend: "Trend jualan",
      paymentMethods: "Kaedah pembayaran",
      payMixEwallet: "e-Dompet (TNG / GoPay)",
      payMixCard: "Kad kredit / debit",
      payMixCash: "Tunai",
      topPerformer: "Prestasi terbaik",
      topPerformerSub: "Pengguna e-dompet Nasi Lemak",
      revenueTrend: "Trend hasil",
      revenueTrendSub: "Gambaran keseluruhan prestasi kewangan harian",
      legendRefunds: "Bayaran Balik",
      dailyBreakdown: "Pecahan harian",
      colDate: "Tarikh",
      colRefunds: "Bayaran Balik",
      colNetRevenue: "Hasil bersih",
      recentFinancialTx: "Transaksi kewangan terkini",
      viewAll: "Lihat semua",
      colTxnId: "ID Transaksi",
      colStatus: "Status",
      colMethod: "Kaedah",
      colAmount: "Jumlah",
      riskCancelRate: "Kadar pembatalan",
      riskRefundRate: "Kadar bayaran balik",
      cancelledOrdersCount: "{{count}} pesanan dibatalkan",
      refundedOrdersCount: "{{count}} pesanan dibayar balik",
      riskCancelledOrders: "Pesanan dibatalkan",
      thisPeriod: "Tempoh ini",
      riskRefundedAmt: "Jumlah dibayar balik",
      totalRefundedHint: "Jumlah dibayar balik",
      highRiskOrders: "Pesanan berisiko tinggi",
      colOrderId: "ID Pesanan",
      colCustomerName: "Nama pelanggan",
      colOrderType: "Jenis pesanan",
      colReason: "Sebab",
      colActions: "Tindakan",
      paginationShowing: "Memaparkan {{start}}–{{end}} daripada {{total}} entri",
      salesByStallTitle: "Jualan mengikut gerai (RM)",
      salesByStallSub: "Pecahan hasil setiap vendor",
      revenueShare: "Bahagian hasil",
      donutTotal: "Jumlah",
      topItemsTitle: "Item terlaris mengikut gerai",
      topItemsSub: "Kedudukan prestasi item menu",
      colRank: "Kedudukan",
      colItemName: "Nama item",
      colUnitsSold: "Unit terjual",
      colRevenueRm: "Hasil (RM)",
      colPerformance: "Prestasi",
      colCommission: "Komisen",
      commissionThreshold: "Ambang (≤)",
      commissionFlatFee: "Yuran tetap",
      commissionPercent: "Peratus (>ambang)",
      commissionSave: "Simpan peraturan komisen",
      addonCommissionPercent: "Potongan tambahan (%)",
      commissionReportOnlyHint: "Kadar ini hanya untuk pengiraan potongan kos/penyesuaian laporan ini sahaja — berasingan daripada Peraturan Harga, dan tidak sekali-kali menjejaskan jumlah sebenar yang dikenakan kepada pelanggan semasa checkout.",
      staffBadgeVsLw: "+12% berbanding minggu lepas",
      staffActiveToday: "Kakitangan aktif hari ini",
      staffRegisteredOf: "/ {{count}} berdaftar",
      avgSessionDuration: "Purata tempoh sesi",
      perStaffToday: "Setiap kakitangan hari ini",
      totalLoginSessions: "Jumlah sesi log masuk",
      includingRelogins: "Termasuk log masuk semula",
      staffLoginLogTitle: "Log log masuk / log keluar kakitangan",
      staffLoginLogSub: "Memantau sesi peranti aktif",
      searchStaffPh: "Cari nama kakitangan…",
      colStaffName: "Nama kakitangan",
      colDevice: "Peranti",
      colLoginTime: "Masa log masuk",
      colLogoutTime: "Masa log keluar",
      colDuration: "Tempoh",
      ongoing: "(sedang berjalan)",
      sessionFootnote:
        "* Sesi direkodkan apabila kakitangan log masuk dan log keluar dari POS tablet. Tempoh dikemas kini secara masa nyata.",
      statusCancelled: "Dibatalkan",
      statusRefunded: "Dibayar Balik",
      staffOnline: "● Dalam talian",
      staffOnlineRelogin: "● Dalam talian (log masuk semula)",
      staffLoggedOut: "Log keluar",
      demo: {
        dash: "—",
        avgSessionSample: "5h 22m",
        riskStatCancelRate: "4.2%",
        riskStatRefundRate: "1.0%",
        riskRefundedAmount: "RM 185.00",
        risk: {
          trm1042: { customer: "Ahmad Fadzil", reason: "Tiada penunggang tersedia" },
          trm1038: { customer: "Sarah Lim", reason: "Item salah dihantar" },
          trm1035: { customer: "John Tan", reason: "Penghantaran lewat (>45m)" },
          trm1031: { customer: "Mei Ling", reason: "Pelanggan tiada di lokasi" },
        },
        staff: {
          s0: {
            name: "Ahmad Bakar",
            device: "Tablet 1",
            login: "7:02 AM",
            logout: "—",
            duration: "7h 13m",
          },
          s1: {
            name: "Siti Aminah",
            device: "Tablet 2",
            login: "8:15 AM",
            logout: "2:15 PM",
            duration: "6h 00m",
          },
          s2: {
            name: "Jason Tan",
            device: "Tablet 1",
            login: "9:00 AM",
            logout: "—",
            duration: "5h 15m",
          },
          s3: {
            name: "Mary Jane",
            device: "Tablet 2",
            login: "7:30 AM",
            logout: "12:00 PM",
            duration: "4h 30m",
          },
          s4: {
            name: "Mary Jane",
            device: "Tablet 2",
            login: "1:00 PM",
            logout: "—",
            duration: "3h 15m",
          },
          s5: {
            name: "Lee Chong Wei",
            device: "Tablet 1",
            login: "6:45 AM",
            logout: "3:30 PM",
            duration: "8h 45m",
          },
        },
        top: {
          nasi: [
            "Nasi Lemak Ayam Berempah",
            "Nasi Lemak Biasa",
            "Nasi Lemak Sambal Sotong",
            "Sambal Tambahan",
          ],
          drinks: ["Teh Tarik", "Milo Ais", "Teh O Ais Limau", "Kopi O"],
          wok: ["Nasi Goreng", "Char Kway Teow", "Mee Goreng Mamak"],
          mamak: ["Roti Canai", "Maggi Goreng", "Naan + Kari"],
        },
      },
    },
    activity: {
      title: "Log Aktiviti",
      colStaff: "Kakitangan",
      colAction: "Tindakan",
      colEntity: "Entiti",
      colDetails: "Butiran",
      colIp: "Alamat IP",
      colTime: "Masa",
      searchPlaceholder: "Cari kakitangan, no. pesanan (cth. 5906) atau butiran…",
      filterAction: "Tapis tindakan",
      exportCsv: "Eksport CSV",
      clearFilters: "Kosongkan penapis",
      allActions: "Semua tindakan",
      eventsRecorded: "{{count}} peristiwa direkodkan",
      footerShowing: "Halaman {{page}} · {{total}} jumlah peristiwa",
    },
    notifications: {
      deliveryFailedTitle: "Penghantaran gagal — Pesanan {{code}}",
      title: "Pemberitahuan",
      markAllRead: "Tandai semua dibaca",
      empty: "Tiada pemberitahuan lagi.",
      resolved: "Diselesaikan",
      unresolved: "Belum diselesaikan",
    },
    imageUpload: {
      imagesOnly: "Hanya fail imej dibenarkan",
      maxSize: "Imej mesti kurang daripada 5 MB",
      uploadFailed: "Muat naik gagal",
      upload: "Muat naik",
      previewAlt: "Pratonton imej dimuat naik",
      clickOrDrag: "Klik untuk muat naik atau seret dan lepas",
      hintFormats: "SVG, PNG, JPG (maks. 5 MB). Disyorkan nisbah persegi 1:1.",
      menuItemHint: "Disyorkan: 1200×1200px, JPG, bawah 1MB. Persegi, hidangan di tengah — dipaparkan sebagai lakaran kecil dalam senarai menu dan skrin utama.",
      stallHint: "PNG, JPG atau WebP sehingga 5 MB. Gambar gerai landskap yang jelas disyorkan.",
      squareLabel: "Foto Persegi (lakaran kecil)",
      wideLabel: "Foto Landskap (banner)",
      wideHint: "Disyorkan: 1200×900px, JPG, bawah 1MB. Landskap, hidangan di tengah — dipaparkan sebagai banner pada halaman butiran item. Pilihan — kembali ke foto persegi jika tidak ditetapkan.",
    },
    statusTag: {
      new: "Baru",
      pending: "Tertangguh",
      confirmed: "Disahkan",
      preparing: "Sedang Disediakan",
      ready: "Siap",
      out_for_delivery: "Dalam Penghantaran",
      in_transit: "Dalam Perjalanan",
      delivered: "Dihantar",
      completed: "Selesai",
      cancelled: "Dibatalkan",
      paid: "Telah Dibayar",
      unpaid: "Belum Dibayar",
      refunded: "Dibayar Balik",
      partially_refunded: "Bayaran Balik Separa",
      approved: "Diluluskan",
      rejected: "Ditolak",
      pending_review: "Menunggu Semakan",
      active: "Aktif",
      inactive: "Tidak Aktif",
      open: "Buka",
      closed: "Tutup",
    },
    issueRefund: {
      title: "Proses bayaran balik",
      notFound: "Transaksi tidak dijumpai.",
      txnId: "ID TXN:",
      orderId: "ID Pesanan:",
      datePaid: "Tarikh dibayar",
      back: "Kembali",
      sectionRefundType: "Jenis bayaran balik",
      fullRefund: "Bayaran balik penuh",
      fullRefundDesc: "Bayar balik jumlah penuh transaksi sebanyak RM {{amount}} kepada sumber asal.",
      partialRefund: "Bayaran balik separa",
      partialDesc: "Nyatakan jumlah tersuai untuk dipulangkan kepada pelanggan.",
      maxRefundable: "Maksimum boleh dibayar balik: RM {{amount}}",
      overLimit: "Jumlah bayaran balik melebihi RM {{amount}} — sila kurangkan",
      sectionBreakdown: "Pecahan bayaran balik",
      foodBev: "Makanan & minuman",
      deliveryFee: "Yuran penghantaran",
      sst: "SST ({{rate}}%)",
      appliedDiscount: "Diskaun terpakai",
      refundAmountRow: "Jumlah bayaran balik",
      totalRefundAmount: "Jumlah keseluruhan bayaran balik",
      sectionReason: "Sebab & dokumentasi",
      refundReasonLabel: "Sebab bayaran balik",
      reasonPlaceholder: "Pilih sebab…",
      internalNote: "Nota dalaman",
      internalOptional: "(pilihan)",
      internalPlaceholder: "Butiran untuk pengauditan peniaga…",
      sectionMethod: "Kaedah bayaran balik",
      methodDescFallback: "Dana akan dipulangkan kepada instrumen pembayaran asal.",
      originalPaid: "Jumlah asal dibayar",
      settlementSummary: "Ringkasan penyelesaian",
      warningIrreversible: "Tindakan ini tidak boleh dibatalkan. Bayaran balik akan dihantar ke get pembayaran serta-merta.",
      confirmCheckbox: "Saya sahkan telah menyemak pesanan ini dan membenarkan bayaran balik ini.",
      confirmRefund: "Sahkan bayaran balik",
      cancelReturn: "Batal dan kembali",
      merchantId: "ID Peniaga:",
      authorizedBy: "Dibenarkan oleh:",
      roleAdmin: "admin",
      partialTipTitle: "Petua bayaran balik separa",
      partialTipBody: "Untuk item yang tertinggal, gunakan harga seunit sebelum SST untuk pembayaran balik yang tepat.",
      success: "Bayaran balik berjaya dimulakan",
      failed: "Gagal memulakan bayaran balik. Sila cuba lagi.",
      payVisa: "Visa / kad — disahkan",
      payFpx: "FPX — disahkan",
      payGrab: "GrabPay — disahkan",
      payCash: "Tunai",
      payEwallet: "eWallet — disahkan",
      payTng: "Touch 'n Go — disahkan",
      payBoost: "Boost — disahkan",
      descVisa: "Dipulangkan ke kad asal. 5–7 hari bekerja.",
      descFpx: "Dipulangkan ke instrumen asal. 3–5 hari bekerja.",
      descGrab: "Dipulangkan ke dompet GrabPay. 1–3 hari bekerja.",
      descCash: "Serahkan tunai terus kepada pelanggan.",
      descEwallet: "Dipulangkan ke eWallet asal. 1–3 hari bekerja.",
      descTng: "Dipulangkan ke dompet Touch 'n Go. 1–3 hari bekerja.",
      descBoost: "Dipulangkan ke dompet Boost. 1–3 hari bekerja.",
      reasonCustomerCancelled: "Pelanggan membatalkan",
      reasonOutOfStock: "Stok habis",
      reasonWrongItem: "Item salah",
      reasonDuplicate: "Pembayaran pendua",
      reasonNotDelivered: "Pesanan tidak dihantar",
      reasonQuality: "Isu kualiti",
      reasonOther: "Lain-lain",
    },
    receipt: {
      metaReceiptNo: "No. resit",
      metaOrderId: "ID Pesanan",
      metaDateTime: "Tarikh & masa",
      metaPaymentMethod: "Kaedah pembayaran",
      metaCustomerName: "Nama pelanggan",
      metaCustomerPhone: "Telefon pelanggan",
      metaOrderChannel: "Saluran pesanan",
      tel: "Tel.",
      colItemName: "Nama item",
      colQty: "Kuantiti",
      colPriceRm: "Harga (RM)",
      colSubtotalRm: "Subjumlah (RM)",
      subtotal: "Subjumlah",
      deliveryFee: "Yuran penghantaran",
      discount: "Diskaun",
      totalPaid: "Jumlah dibayar",
      sstPct: "SST ({{pct}}%)",
      refundedAmount: "Jumlah dibayar balik",
      refundDate: "Tarikh bayaran balik",
      thankYou: "Terima kasih atas pembelian Anda",
      systemGenerated: "Ini adalah resit yang dijana oleh sistem",
      downloadPdf: "Muat turun PDF",
      printReceipt: "Cetak resit",
      close: "Tutup",
      printTitle: "Resit",
      optionsPlus: "+",
      payVisa: "Visa / Kad",
      payFpx: "FPX",
      payGrab: "GrabPay",
      payCash: "Tunai",
      payEwallet: "eWallet",
      payTng: "Touch 'n Go",
      payBoost: "Boost",
      channelDelivery: "Penghantaran",
      channelPickup: "Ambil sendiri",
      channelOther: "Pesanan",
    },
    addMenuItem: {
      titlePage: "Tambah item baharu",
      titlePageEdit: "Edit item",
      successCreate: "Item menu dicipta",
      successUpdate: "Item menu dikemaskini",
      failedCreate: "Gagal mencipta item menu",
      failedUpdate: "Gagal mengemaskini item menu",
      successAnother: "Item disimpan! Isi satu lagi.",
      sectionBasic: "Maklumat asas",
      itemName: "Nama item",
      itemNameRequired: "Nama item diperlukan",
      namePlaceholder: "cth. Nasi Lemak Ayam Goreng",
      stall: "Gerai",
      tagRequired: "Wajib",
      selectStallPh: "Pilih gerai",
      category: "Kategori",
      selectCategoryPh: "Pilih kategori",
      stallPaused: "{{name}} kini dijeda. Item ini tidak akan tersedia sehingga gerai disambung semula.",
      description: "Penerangan",
      descPlaceholder: "Penerangan ringkas tentang item ini",
      sectionPricing: "Harga & ketersediaan",
      basePrice: "Harga asas",
      priceRequired: "Harga diperlukan",
      availableForOrder: "Tersedia untuk pesanan",
      availableHint: "Matikan untuk menyembunyikan daripada menu pelanggan",
      pinToTop: "Sematkan di atas",
      pinToTopHint: "Paparkan item ini dahulu dalam menu pelanggan",
      advancedOptions: "Pilihan lanjutan",
      offerPrice: "Harga promosi (RM)",
      dailyStock: "Stok harian",
      dailyStockPh: "cth. 50",
      takeawayCutlery: "Bayaran peralatan makan bawa pulang",
      takeawayCutleryHint: "Dikenakan seunit pada pesanan ambil sendiri dan penghantaran; pelanggan tidak boleh menolak.",
      takeawayCutleryFee: "Bayaran seunit",
      takeawayCutleryFeeRequired: "Masukkan bayaran peralatan makan",
      sortOrder: "Susunan",
      availableFrom: "Tersedia dari",
      availableUntil: "Tersedia hingga",
      offerFrom: "Promosi dari",
      timePh: "07:00",
      timePhEnd: "22:00",
      timePhOffer: "10:00",
      sectionImage: "Gambar item",
      sectionCustomization: "Enjin penyesuaian",
      enableCustomization: "Aktifkan penyesuaian",
      custPromptTitle: "Aktifkan untuk menambah penyesuaian",
      custPromptBody:
        'Hidupkan "Aktifkan penyesuaian" di atas untuk menambah kumpulan pilihan seperti saiz, tambahan dan tahap manis.',
      noGroupsYet: 'Belum ada kumpulan pilihan. Klik "Tambah kumpulan pilihan" untuk mula.',
      addOptionGroup: "Tambah kumpulan pilihan",
      copyExistingGroup: "Salin kumpulan pilihan daripada hidangan lain di gerai ini…",
      icon: "Ikon",
      groupName: "Nama kumpulan",
      groupNamePh: "Nama kumpulan (cth. tahap gula, tambahan)",
      fieldRequired: "Wajib",
      selection: "Pemilihan",
      selectionSingle: "Pilihan tunggal",
      selectionMultiple: "Pilihan berbilang",
      min: "Min",
      max: "Maks",
      removeGroup: "Buang kumpulan",
      colOptionName: "Nama pilihan",
      colPriceAdj: "Pelarasan harga (RM)",
      colType: "Jenis",
      colDefault: "Lalai",
      optionNamePh: "Nama pilihan",
      typeRadio: "Radio",
      typeInput: "Input",
      typeTextarea: "Kotak teks",
      typeQuantity: "Tambahan kuantiti",
      addOption: "Tambah pilihan",
      customerPreview: "Pratonton pelanggan",
      selectStallPreview: "Pilih gerai di atas",
      previewNameFallback: "Pratonton nama item",
      previewDescHint: "Penerangan akan dipaparkan di sini sebaik sahaja Anda menaip dalam bahagian butiran.",
      badgeAvailable: "Tersedia",
      badgeUnavailable: "Tidak tersedia",
      customizeYourOrder: "Sesuaikan pesanan Anda",
      mandatoryComplete: "Semua medan wajib telah lengkap",
      mandatoryIncomplete: "Isi medan wajib untuk teruskan",
      saveAddAnother: "Simpan & tambah satu lagi",
      saveItem: "Simpan item",
      groupIconSugar: "Tahap gula",
      groupIconIce: "Tahap ais",
      groupIconSpecial: "Permintaan khas",
    },
    featureFlags: {
      title: "Flag Ciri",
      pageSubtitle: "Urus keupayaan platform, status ketersediaan dan pelancaran di satu tempat.",
      statTotal: "Jumlah flag",
      statEnabled: "Diaktifkan",
      statDisabled: "Dilumpuhkan",
      statBadgeTotal: "Semua keupayaan",
      statBadgeEnabled: "Tersedia sekarang",
      statBadgeDisabled: "Tidak aktif",
      toggleLabel: "Togol {{key}}",
      colFlagKey: "Kunci Flag",
      colDescription: "Penerangan",
      colEnabled: "Diaktifkan",
      noDescription: "Tiada penerangan",
      flagEnabled: 'Flag "{{key}}" diaktifkan',
      flagDisabled: 'Flag "{{key}}" dilumpuhkan',
      updateFailed: "Gagal mengemas kini flag",
      desc_lalamove_enabled: "Aktifkan penghantaran penunggang Lalamove untuk pesanan penghantaran",
      desc_email_otp_enabled: "Beralih ke OTP e-mel apabila penghantaran SMS gagal",
      desc_bull_board_enabled: "Dedahkan UI pentadbir baris gilir tugas latar belakang di /admin/queues",
      desc_customer_push_enabled: "Aktifkan pemberitahuan tolak (push) di pihak pelanggan",
    },
    legalContent: {
      languageLabel: "Bahasa",
      languageHint: "● bermaksud bahasa itu sudah ditulis. Pembaca melihat bahasa mereka sendiri; bahasa yang kosong akan guna versi English.",
      title: "Kandungan Perundangan",
      subtitle: "Edit Terma dan Syarat / Dasar Privasi yang dipaparkan pada setiap apl. Perubahan terpakai serta-merta pada apl tersebut sahaja.",
      applicationLabel: "Aplikasi",
      documentLabel: "Dokumen",
      editorTitle: "Editor dokumen",
      previewSubtitle: "Pratonton paparan pelanggan",
      saveHint: "Perubahan hanya digunakan pada aplikasi yang dipilih.",
      appAdmin: "Panel Pentadbir",
      appPos: "Apl POS",
      appStall: "Apl Gerai",
      appCustomer: "Apl Pelanggan",
      docTerms: "Terma dan Syarat",
      docPrivacy: "Dasar Privasi",
      titleLabel: "Tajuk",
      contentLabel: "Kandungan (Markdown disokong: # tajuk, ## subtajuk, **tebal**, - item senarai)",
      preview: "Pratonton",
      save: "Simpan",
      saveSuccess: "Disimpan",
      saveFailed: "Simpan gagal, sila cuba lagi",
      lastUpdated: "Kemas kini terakhir {{date}}",
      neverUpdated: "Belum dikonfigurasi — memaparkan teks pemegang tempat kepada pengguna",
      unsavedContentHint: "Kandungan kosong akan memaparkan teks pemegang tempat kepada pengguna",
    },
    pricingRules: {
      title: "Peraturan Harga",
      subtitle: "Markup setiap item yang dipaparkan untuk pesanan apl pelanggan (penghantaran + ambil sendiri). Pesanan walk-in POS sentiasa menggunakan harga menu asal.",
      configurationTitle: "Konfigurasi harga",
      configurationSubtitle: "Tetapkan markup pelanggan untuk item asas dan tambahan berbayar.",
      exampleSubtitle: "Nilai dikemas kini serta-merta semasa anda mengedit peraturan. Kadar ini adalah SATU PIHAK: harga pelanggan membawa dua daripadanya (0.50 / 3.5% → harga menu + RM1.00 / 7%) dan gerai ditolak satu (RM0.50 / 3.5%). Harga selepas caj sentiasa dibundarkan KE ATAS kepada 10 sen. Set (bundle) dicaj sekali pada harga akhir set dengan peraturan yang sama.",
      saveHint: "Perubahan berkuat kuasa selepas disimpan.",
      thresholdLabel: "Ambang harga (RM)",
      thresholdHint: "Item berharga pada atau di bawah jumlah ini dikenakan yuran tetap. Item melebihinya dikenakan peratusan sebaliknya.",
      flatFeeLabel: "Yuran tetap untuk item ≤ ambang (RM)",
      percentLabel: "Caj tambahan untuk item > ambang (%)",
      exampleTitle: "Contoh langsung",
      exampleLow: "Item RM {{price}} → pelanggan melihat RM {{result}} (≤ ambang, yuran tetap)",
      exampleHigh: "Item RM {{price}} → pelanggan melihat RM {{result}} (> ambang, caj tambahan {{percent}}%)",
      exampleAddon: "Tambahan RM {{price}} → pelanggan melihat RM {{result}} (markup tambahan {{percent}}%, sentiasa dikenakan)",
      exampleStallNet: "Anggaran hasil gerai RM {{net}} (ditolak RM {{fee}}; platform mengambil RM {{platform}} keseluruhan)",
      addonSectionTitle: "Kadar markup tambahan",
      addonSectionSub: "Dikenakan kepada kos setiap tambahan berbayar secara individu, tanpa mengira cabang yang digunakan oleh harga item asas di atas. Berasingan daripada peraturan item asas.",
      addonPercentLabel: "Markup tambahan (%)",
      saveSuccess: "Peraturan harga disimpan",
      saveFailed: "Gagal menyimpan peraturan harga",
    },
    hours: {
      title: "Waktu & Cuti",
      subtitle: "Urus waktu operasi mingguan dan tarikh penutupan khas.",
      cardOperatingHours: "Waktu Operasi",
      saveHours: "Simpan Waktu",
      cardHolidays: "Cuti / Penutupan",
      colDate: "Tarikh",
      colNote: "Nota",
      addHolidayBtn: "Tambah",
      datePickerPlaceholder: "Pilih tarikh",
      notePlaceholder: "Nota (pilihan)",
      dateRequired: "Pilih tarikh",
      confirmRemoveHoliday: "Buang cuti ini?",
      open: "Buka",
      closed: "Tutup",
      saveSuccess: "Waktu operasi disimpan",
      saveFailed: "Gagal menyimpan waktu",
      updateHolidaySuccess: "Cuti dikemas kini",
      updateHolidayFailed: "Gagal mengemas kini cuti",
      holidayAdded: "Cuti ditambah",
      holidayAddFailed: "Gagal menambah cuti",
      days: {
        sunday: "Ahad",
        monday: "Isnin",
        tuesday: "Selasa",
        wednesday: "Rabu",
        thursday: "Khamis",
        friday: "Jumaat",
        saturday: "Sabtu",
      },
    },
    settings: {
      title: "Tetapan",
      sectionBusiness: "Maklumat Perniagaan",
      sectionTax: "Cukai & Yuran",
      fieldKopitiamName: "Nama Kopitiam",
      fieldAddress: "Alamat",
      fieldPhone: "Telefon Hubungan",
      fieldSstRate: "Kadar SST (%)",
      fieldSstTooltip: "Masukkan dalam peratusan, cth. 6 untuk 6%",
      fieldDeliveryFee: "Yuran Penghantaran Lalai (RM)",
      fieldDeliveryFeeTooltip: "Yuran penghantaran tetap yang dikenakan kepada pelanggan",
      saveBtn: "Simpan Tetapan",
      saveSuccess: "Tetapan disimpan",
      saveFailed: "Gagal menyimpan tetapan",
      addBtn: "Tambah",
    },
    settingsScreen: {
      coordsMissingBanner: "⚠️ Kopitiam (seluruh premis) belum ada koordinat: jarak penghantaran disimpan sebagai 0, had radius tidak dikuatkuasakan dan Lalamove memetik harga dari titik ganti. Semua gerai berkongsi lokasi ini. Buka Tetapan, isi alamat kopitiam dan cari koordinatnya.",
      coordsMissingAction: "Buka Tetapan",
      findByAddress: "Cari koordinat dari alamat",
      geoNeedAddress: "Isi alamat kedai dahulu",
      geoFound: "Koordinat ditemui daripada alamat — semak peta, kemudian tekan Simpan.",
      geoApprox: "⚠️ Ini hanya kawasan umum berhampiran alamat, BUKAN lokasi tepat kedai! Cari nama kedai di Google Maps, klik kanan lokasinya, salin koordinat dan tampal di “Tampal koordinat Google Maps” di bawah, kemudian Simpan.",
      pasteCoordsPh: "Tampal koordinat Google Maps, cth 3.0123, 101.6123",
      pasteCoordsHint: "Paling tepat: cari kedai di Google Maps → klik kanan lokasinya → klik baris pertama (koordinat) untuk salin → tampal di sini.",
      pasteCoordsBad: "Format salah — sepatutnya seperti 3.0123, 101.6123 (latitud, longitud)",
      gKeyTitle: "Kunci API Google Maps (pilihan)",
      gKeyOn: "Ditetapkan (berakhir {{last4}}). Jika “cari koordinat” hanya dapat padanan kasar, Google akan ditanya juga.",
      gKeyOff: "Belum ditetapkan. Setelah ditetapkan, “cari koordinat” juga bertanya Google apabila OpenStreetMap hanya kasar (lebih tepat).",
      gKeyPh: "Tampal kunci API Google Geocoding",
      gKeySave: "Simpan kunci",
      gKeyReplace: "Ganti kunci",
      gKeyRemove: "Buang",
      gKeySaved: "Disimpan",
      gKeyFailed: "Gagal simpan — cuba lagi",
      geoNone: "Tiada koordinat ditemui untuk alamat ini: semak alamat (atau hanya “poskod bandar, negeri”) atau masukkan latitud/longitud secara manual.",
      geoOpenMap: "Lihat di peta",
      geoSaveHint: "Ingat tekan Simpan apabila sudah betul.",
      sstRateInvalid: "Kadar SST diperlukan dan mesti antara 0% dan 100% (isi 0 jika tiada SST)",
      payMethodsMovedHint: "Hidupkan/matikan tunai, e-dompet, kad dan FPX untuk pembayaran dalam talian, termasuk kelayakan gerbang, di skrin Kaedah Pembayaran.",
      otherProvidersHint: "Tetapkan Lalamove, GrabExpress dan penyedia lain, termasuk kelayakan sandbox/produksi dan ujian sambungan, di skrin Penyedia Penghantaran.",
      logoUpdated: "Logo dikemas kini",
      logoUpdateFailed: "Gagal menyimpan logo",
      baseFeeInvalid: "Yuran penghantaran lalai diperlukan dan tidak boleh negatif",
      sstRateRequired: "Kadar SST diperlukan (masukkan 0 jika tidak mengenakan SST)",
      sstRateRange: "Kadar SST mesti antara 0 dan 100",
      baseFeeRequired: "Yuran penghantaran lalai diperlukan",
      baseFeeNotNumber: "Yuran penghantaran tidak boleh negatif atau bukan nombor",
      baseFeeTooHigh: "Yuran penghantaran tidak boleh melebihi RM 200",
      lblAppVersion: "Label versi aplikasi",
      appVersionHint: "Dipaparkan pada profil pelanggan dan di bawah halaman log masuk POS.",
      goToDeliveryProviders: "Urus penyedia penghantaran",
      goToPaymentMethods: "Urus kaedah pembayaran",
      title: "Tetapan",
      subtitle: "Urus operasi kedai, saluran pelanggan dan pilihan sistem dari satu tempat.",
      saveChanges: "Simpan perubahan",
      saveSuccess: "Tetapan berjaya disimpan",
      saveFailed: "Gagal menyimpan tetapan. Sila cuba lagi.",
      storeNameRequired: "Nama kedai diperlukan",
      tabStore: "Maklumat Kedai",
      tabDelivery: "Penghantaran",
      tabTax: "Cukai & Mata Wang",
      tabPayment: "Pembayaran",
      tabPrinter: "Pencetak",
      tabNotifications: "Pemberitahuan",
      tabSms: "Templat SMS",
      smsTemplatesTitle: "Templat Mesej OTP",
      smsTemplatesExtra: "Apa yang dihantar kepada pelanggan semasa log masuk",
      lblSmsDefaultLang: "BAHASA HANTAR LALAI",
      smsDefaultLangHint: "Templat mana di bawah yang benar-benar digunakan untuk hantar kod — boleh tukar bila-bila masa, tiada perubahan kod diperlukan.",
      langChinese: "中文 (Cina)",
      lblSmsTemplateZh: "TEMPLAT CINA",
      lblSmsTemplateEn: "TEMPLAT INGGERIS",
      lblSmsTemplateMs: "TEMPLAT MELAYU",
      defaultBadge: "Lalai",
      smsTemplateHint: "Guna {code} untuk kod pengesahan dan {minutes} untuk tempoh sah dalam minit. Biarkan mana-mana bahasa kosong untuk guna templat terbina-dalam yang ditunjukkan sebagai ruang letaknya.",
      smsPreviewTitle: "Pratonton",
      smsPreviewHint: "Ini adalah tepat apa yang pelanggan terima hari ini, dengan kod contoh.",
      otpLimitsTitle: "Had Kod Pengesahan",
      otpLimitsExtra: "Terpakai untuk kedua-dua OTP SMS dan e-mel.",
      lblOtpDailyCap: "MAKSIMUM HANTAR SEHARI",
      lblOtpCooldownSeconds: "TEMPOH TUNGGU ANTARA HANTARAN (SAAT)",
      lblOtpExpirySeconds: "KOD SAH SELAMA (SAAT)",
      lblOtpCodeLength: "PANJANG KOD (DIGIT)",
      tabRegistration: "Pendaftaran",
      registrationTitle: "Pendaftaran Pelanggan",
      registrationExtra: "Kawal saluran yang boleh digunakan pelanggan baharu untuk mendaftar.",
      allowEmailRegistration: "Benarkan pendaftaran e-mel",
      allowEmailRegistrationDesc: "Benarkan pelanggan baharu mendaftar menggunakan alamat e-mel.",
      allowPhoneRegistration: "Benarkan pendaftaran telefon",
      allowPhoneRegistrationDesc: "Benarkan pelanggan baharu mendaftar menggunakan nombor telefon.",
      tabEmail: "E-mel",
      emailTitle: "Penghantaran E-mel",
      emailExtra: "Konfigurasikan Resend atau SMTP supaya kod pendaftaran dan set semula kata laluan boleh dihantar melalui e-mel.",
      emailEnabled: "Aktifkan penghantaran e-mel",
      emailEnabledDesc: "Apabila dimatikan, kod hanya direkodkan bukan dihantar — berguna sebelum anda mempunyai kelayakan sebenar.",
      emailProvider: "PEMBEKAL",
      emailProviderSmtp: "SMTP (cth. Gmail)",
      resendApiKey: "RESEND API KEY",
      emailFromAddress: "ALAMAT PENGHANTAR",
      smtpHost: "HOS SMTP",
      smtpPort: "PORT",
      smtpSecure: "Guna SSL (port 465)",
      smtpUser: "NAMA PENGGUNA SMTP",
      smtpPass: "KATA LALUAN SMTP",
      smtpPassPlaceholder: "Gmail: guna App Password, bukan kata laluan log masuk anda",
      emailTemplatesTitle: "Templat E-mel",
      emailTemplatesExtra: "Sesuaikan kandungan e-mel OTP mengikut bahasa.",
      lblEmailTemplateDefaultLang: "BAHASA LALAI",
      emailTemplateHint: "Bahasa ini digunakan semasa menghantar e-mel OTP.",
      lblEmailTemplateSubject: "SUBJEK",
      lblEmailTemplateHeading: "TAJUK",
      lblEmailTemplateIntro: "TEKS PENGENALAN",
      lblEmailTemplateOutro: "TEKS PENUTUP",
      emailTemplatePlaceholderHint: "Guna {code} untuk kod pengesahan dan {minutes} untuk tempoh sah. Biarkan kosong untuk guna teks lalai.",
      sectionBasicInfo: "Maklumat Asas",
      lblStoreName: "NAMA KEDAI",
      lblPhone: "TELEFON",
      lblEmail: "E-MEL",
      lblAddress: "ALAMAT",
      lblLatitude: "LATITUD",
      lblLongitude: "LONGITUD",
      useCurrentLocation: "Guna lokasi semasa",
      locationHint: "Koordinat pengambilan sebenar untuk medan selera ini — digunakan sebagai titik asal sebut harga penghantaran supaya yuran dan penghantaran Lalamove mencerminkan jarak sebenar dan bukan pemegang tempat.",
      geolocationUnsupported: "Lokasi tidak disokong oleh pelayar ini",
      geolocationFailed: "Tidak dapat mengesan lokasi Anda",
      phPhone: "03-1234 5678",
      phEmail: "hello@kopitiam.com",
      sectionOrderTypes: "Jenis pesanan diterima",
      allowPickupTitle: "Benarkan pesanan ambil sendiri",
      allowPickupDesc: "Pelanggan boleh membuat pesanan dalam talian dan mengambilnya di kedai",
      allowDeliveryTitle: "Benarkan pesanan penghantaran",
      allowDeliveryDesc:
        "Aktifkan penghantaran ke rumah melalui penunggang sendiri atau pihak ketiga",
      sectionBranding: "Penjenamaan Kedai",
      brandLogoTitle: "Logo Jenama",
      brandLogoHint:
        "Format diterima: PNG, JPG (Maks 2MB). Saiz disyorkan: 512x512px.",
      uploadLogo: "Muat Naik Logo Baharu",
      sectionHours: "Waktu operasi",
      applyAllDays: "✓ Guna untuk semua hari",
      open: "BUKA",
      closed: "TUTUP",
      holidayHintBefore: "Penutupan cuti boleh diuruskan di bahagian",
      holidayHintLink: "Tarikh Khas",
      holidayHintAfter: ".",
      sectionDeliveryFee: "Yuran penghantaran",
      lblBaseFee: "YURAN ASAS",
      hintBaseFee: "Harga permulaan tetap untuk sebarang penghantaran",
      lblFeePerKm: "YURAN SETIAP KM",
      hintFeePerKm: "Caj ditambah untuk setiap kilometer perjalanan",
      lblMinFee: "YURAN MINIMUM",
      hintMinFee: "Caj penghantaran paling rendah yang mungkin",
      lblMaxFee: "HAD YURAN MAKSIMUM",
      hintMaxFee: "Caj penghantaran paling tinggi yang mungkin",
      lblMarkupPct: "MARKUP %",
      hintMarkupPct: "Peratusan markup ditambah kepada yuran yang dikira",
      feePreview: "Pratonton yuran",
      dynamicEstimate: "ANGGARAN DINAMIK",
      kmUnit: "{{n}} km",
      outOfRange: "DI LUAR JULAT",
      sectionDeliveryRadius: "Radius Penghantaran",
      lblMaxRadius: "RADIUS PENGHANTARAN MAKS",
      hintRadius: "Pesanan di luar julat ini akan ditolak",
      kmSuffix: "km",
      saveFailedRadiusExceeded: "Radius penghantaran maksimum tidak boleh melebihi {{max}} km",
      sectionRiderAssignment: "Penugasan penunggang",
      readOnly: "BACA SAHAJA",
      lblMethod: "KAEDAH",
      riderMethodManual: "Manual (admin menugaskan penunggang)",
      riderGpsNote:
        "Sistem ini menggunakan penugasan penunggang secara manual. Penjejakan GPS tidak tersedia untuk penunggang dalaman.",
      thirdPartyTitle: "Integrasi penghantaran pihak ketiga",
      thirdPartySubtitle:
        "Automasikan penghantaran dengan menyambung kepada penyedia logistik.",
      providerNone: "Tiada (manual)",
      providerLalamove: "Lalamove",
      providerGrabExpress: "GrabExpress",
      connected: "DISAMBUNGKAN",
      setupRequired: "PERLU DISEDIAKAN",
      lblApiKey: "KUNCI API",
      lastVerified: "Disahkan kali terakhir: Hari ini, 9:00 AM",
      disconnect: "Putuskan sambungan",
      editCredentials: "Edit kelayakan",
      lblClientId: "ID KLIEN",
      phEnterId: "Masukkan ID",
      lblClientSecret: "RAHSIA KLIEN",
      lblCountry: "NEGARA",
      countryMalaysia: "Malaysia",
      lblEnvironment: "PERSEKITARAN",
      envSandbox: "Sandbox",
      envProduction: "Produksi",
      testConnection: "Uji sambungan",
      sstConfigTitle: "Konfigurasi SST",
      sstConfigSubtitle:
        "Konfigurasikan Cukai Jualan dan Perkhidmatan Malaysia (SST) untuk item Anda.",
      chargeSstLabel: "Kenakan SST pada pesanan",
      lblSstRate: "KADAR SST %",
      calcFormula: "FORMULA PENGIRAAN",
      calcFormulaBody: "Harga pelanggan = harga selepas markup x (1 + SST %), dibundarkan ke atas kepada 10 sen",
      exampleLabel: "Contoh:",
      exampleBody: "RM 10.00 x (1 + {{rate}}%), dibundarkan ke atas =",
      currencyTitle: "Paparan mata wang",
      currencySubtitle:
        "Tetapan global untuk cara nilai mata wang dipaparkan merentas POS dan Terminal.",
      lblCurrency: "MATA WANG",
      currencyReadonly: "MYR — Ringgit Malaysia",
      lblDisplayFormat: "FORMAT PAPARAN",
      displayFormatSample: "RM 12.50",
      lblStorageFormat: "FORMAT PENYIMPANAN",
      storageFormatSample: "Integer (sen) cth. 1250",
      currencyLockedNote:
        "Tetapan mata wang adalah tetap. Hubungi sokongan untuk menukarnya.",
      taxHelpTitle: "Perlukan bantuan dengan Peraturan Cukai?",
      taxHelpSubtitle:
        "Lihat panduan SST terkini daripada Jabatan Kastam Diraja Malaysia.",
      learnMore: "KETAHUI LEBIH LANJUT",
      payMethodsTitle: "Kaedah pembayaran",
      payMethodsSubtitle: "Konfigurasikan cara pelanggan Anda membayar pesanan mereka.",
      payMinOneHint: "Sekurang-kurangnya satu kaedah pembayaran mesti diaktifkan.",
      transactionSettingsTitle: "Tetapan transaksi",
      txnRecordedLabel: "TRANSAKSI DIREKODKAN",
      txnRecordedDesc: "Hanya direkodkan selepas pembayaran berjaya",
      failedPayLabel: "PEMBAYARAN GAGAL",
      failedPayDesc: "Tidak disimpan dalam sistem",
      cashRefundTitle: "Bayaran balik tunai",
      cashRefundDesc: "Benarkan bayaran balik tunai diproses di daftar tunai",
      bankRefundTitle: "Bayaran balik pemindahan bank",
      bankRefundDesc: "Aktifkan aliran kerja bayaran balik bank automatik",
      refundsManualNote: "Bayaran balik diproses secara manual oleh admin.",
      payCashName: "Tunai",
      payCashDesc: "Pelanggan membayar secara peribadi",
      payDuitnowName: "DuitNow QR",
      payDuitnowDesc: "Pemindahan bank segera melalui QR",
      payFpxName: "Perbankan Dalam Talian (FPX)",
      payFpxDesc: "Pemindahan bank terus",
      payCardName: "Kad Kredit / Debit",
      payCardDesc: "Visa, Mastercard",
      payGrabpayName: "GrabPay",
      payGrabpayDesc: "e-dompet GrabPay",
      payTngName: "Touch 'n Go eWallet",
      payTngDesc: "Pembayaran eWallet TNG",
      printerSetup: "Persediaan pencetak",
      testPrint: "Uji Cetak",
      lblPrinterName: "NAMA PENCETAK",
      printerNameDefault: "Pencetak Dapur Utama",
      lblConnType: "JENIS SAMBUNGAN",
      connNetwork: "Rangkaian",
      connUsb: "USB",
      connBluetooth: "Bluetooth",
      lblIpAddress: "ALAMAT IP",
      lblPaperWidth: "LEBAR KERTAS",
      autoPrintTitle: "Tetapan cetak automatik",
      autoKitchenName: "Cetak slip dapur apabila pesanan diterima",
      autoKitchenDesc: "Dihantar ke pencetak dapur secara automatik",
      autoReceiptName: "Cetak resit apabila pesanan selesai",
      autoReceiptDesc: "Resit pelanggan dicetak selepas selesai",
      manualPrintName: "Cetak hanya apabila dicetuskan secara manual",
      manualPrintDesc: "Kakitangan mencetak secara manual dari butiran pesanan",
      kitchenSlipTitle: "Kandungan slip dapur",
      kitchenOrderId: "ID Pesanan",
      kitchenOrderType: "Jenis pesanan",
      kitchenCustomerName: "Nama pelanggan",
      kitchenItems: "Senarai item dengan penyesuaian",
      kitchenSpecial: "Arahan khas",
      kitchenEstTime: "Anggaran masa",
      receiptContentTitle: "Kandungan resit",
      receiptStoreAddr: "Nama & alamat kedai",
      receiptOrderDate: "ID Pesanan & tarikh",
      receiptItemsPrices: "Senarai item dengan harga",
      receiptSubtotal: "Subjumlah, yuran penghantaran, SST, diskaun",
      receiptTotal: "Jumlah keseluruhan",
      receiptPayMethod: "Kaedah pembayaran",
      livePreviewTitle: "Pratonton Resit Langsung",
      livePreviewSubtitle:
        "Perubahan pada kandungan slip dan resit Anda akan dikemas kini serta-merta dalam papan pemuka peniaga Anda.",
      previewStoreName: "KOPITIAM HUB",
      previewStoreAddr: "123 Jalan, Kuala Lumpur",
      previewItem1: "1x Teh O Ais",
      previewItem1Note: "- Tanpa Gula",
      previewItem2: "1x Roti Bakar Kaya",
      previewTotal: "JUMLAH",
      previewThankYou: "Terima Kasih Atas Kunjungan Anda!",
      previewPrice1: "RM 3.50",
      previewPrice2: "RM 4.80",
      previewTotalAmount: "RM 8.30",
      demoMaskedApiKey: "sk_live_*******a2f",
      orderAlertsTitle: "Amaran pesanan",
      orderAlertsExtra:
        "Konfigurasikan cara Anda dimaklumkan tentang aktiviti kedai secara masa nyata.",
      alertNewOrder: "Pesanan baharu diterima",
      alertCancelled: "Pesanan dibatalkan automatik",
      alertRider: "Penunggang ditugaskan untuk penghantaran",
      alertDelayed: "Pesanan tertangguh",
      tagSoundAlert: "AMARAN BUNYI",
      tagTabletPush: "TOLAK TABLET",
      stallNotifTitle: "Pemberitahuan gerai",
      stallNotifDesc:
        "Setiap gerai menerima pemberitahuan tolak pada peranti masing-masing yang hanya memaparkan item mereka apabila pesanan diterima.",
      flowAccepted: "Pesanan diterima",
      flowFilters: "Sistem menapis item mengikut gerai",
      flowEachNotified: "Setiap gerai dimaklumkan hanya dengan item mereka",
      stallSampleNasi: "Gerai Nasi Lemak",
      stallSampleDrinks: "Gerai Minuman",
      stallSampleWok: "Gerai Wok",
      stallSampleMamak: "Gerai Mamak",
      stallDevice1: "iPhone Ali Hassan",
      stallDevice2: "Samsung Nurul Ain",
      stallDevice4: "iPhone 12 Rajan",
      stallInfo1: "iOS 17 • AKTIF HARI INI",
      stallInfo2: "Android 14 • AKTIF HARI INI",
      stallInfo4: "iOS 16 • AKTIF 2 HARI LALU",
      notLinked: "TIDAK DIPAUTKAN",
      pairingCode: "KP-7F2A",
      enableAllStallsTitle: "Aktifkan semua pemberitahuan gerai",
      enableAllStallsDesc:
        "Hidup atau matikan amaran khusus gerai secara global.",
      lblNotifLang: "BAHASA PEMBERITAHUAN",
      langEnglish: "English",
      langMalay: "Bahasa Melayu",
      alertSoundTitle: "Bunyi amaran",
      lblVolume: "KELANTANGAN",
      lblSoundTheme: "TEMA BUNYI",
      soundChime: "Deringan",
      soundBell: "Loceng",
      soundDing: "Ding",
      previewSound: "Pratonton bunyi",
      channelsTitle: "Saluran",
      tabletPushTitle: "Pemberitahuan tolak tablet",
      tabletPushDesc:
        "Hantar amaran pop-up ke semua tablet peniaga yang aktif.",
      soundAlertChannelTitle: "Amaran bunyi",
      soundAlertChannelDesc:
        "Mainkan bunyi tema yang dipilih apabila pemberitahuan tiba.",
      smsEmailUnavailable:
        "Pemberitahuan SMS dan e-mel tidak tersedia dalam versi ini.",
      newOrderAlertBanner: "AMARAN PESANAN BAHARU",
      previewBadge: "PRATONTON",
      previewOrderTitle: "Pesanan #1042 — Gerai Nasi Lemak",
      previewOrderItems: "Nasi Lemak Ayam x2, Nasi Lemak Ikan x1",
    },
    stalls: {
      title: "Gerai",
      pageSubtitle: "Urus butiran gerai, status operasi dan susunan paparan pelanggan",
      statTotal: "Jumlah gerai",
      statOpen: "Gerai dibuka",
      statPaused: "Gerai dijeda",
      statBadgeOverall: "Keseluruhan",
      statBadgeOpen: "Dibuka",
      statBadgePaused: "Dijeda",
      drawerSubtitleNew: "Masukkan butiran gerai dan tetapan operasi",
      addStall: "Tambah Gerai",
      editTitle: "Edit gerai",
      basicInfo: "Maklumat Asas",
      status: "Status",
      stallStatus: "Status Gerai",
      stallStatusHint:
        "Jika dijeda, semua item di bawah gerai ini tidak akan tersedia",
      displayOrder: "Susunan Paparan",
      displayOrderHint: "Nombor lebih rendah dipaparkan dahulu dalam apl pelanggan",
      openingHours: "Waktu Operasi",
      weekdaysHours: "Isnin – Jumaat",
      weekendHours: "Sabtu – Ahad",
      stallName: "Nama Gerai",
      stallNameRequired: "Nama gerai diperlukan",
      stallNamePlaceholder: "cth. Gerai Minuman",
      description: "Penerangan",
      descriptionPlaceholder: "Penerangan ringkas tentang gerai",
      discard: "Buang",
      createStall: "Cipta Gerai",
      createSuccess: "Gerai dicipta",
      createFailed: "Gagal mencipta gerai",
      updateSuccess: "Gerai dikemas kini",
      saveFailed: "Gagal menyimpan gerai",
      opened: "Gerai dibuka",
      closed: "Gerai ditutup",
      colCover: "Penutup",
      colName: "Nama",
      colDescription: "Penerangan",
      colSortOrder: "Susunan",
      colSst: "SST",
      colOpen: "Buka",
      colActions: "Tindakan",
      tooltipEdit: "Edit gerai",
      tooltipDelete: "Padam gerai",
      deleteConfirm: "Padam gerai ini? Menunya akan disembunyikan daripada semua aplikasi.",
      deleteSuccess: "Gerai dipadam",
      deleteFailed: "Gagal memadam gerai",
      formName: "Nama",
      formDescription: "Penerangan",
      formCoverImage: "Gambar penutup gerai",
      formSortOrder: "Susunan",
      formIsOpen: "Buka untuk pesanan",
      formSst: "Kadar SST %",
      formSstHint: "Kosongkan untuk ikut SST global; 0 = tiada SST untuk gerai ini. Cukai sudah termasuk dalam harga dan hanya untuk pesanan baharu.",
      sstFollowGlobal: "Global",
      coverUrlPlaceholder: "https://…",
      hoursWeekdayExample: "08:00 AM – 10:00 PM",
      hoursWeekendExample: "09:00 AM – 11:00 PM",
    },
    banners: {
      title: "Sepanduk Promosi",
      pageSubtitle: "Urus kandungan promosi, susunan paparan dan status penerbitan",
      statTotal: "Jumlah sepanduk",
      statActive: "Aktif",
      statInactive: "Tidak aktif",
      statBadgeOverall: "Semua sepanduk",
      statBadgeActive: "Sedang dipaparkan",
      statBadgeInactive: "Dijeda",
      add: "Tambah Sepanduk",
      editTitle: "Edit Sepanduk",
      createTitle: "Sepanduk Baharu",
      colOrder: "Susunan",
      colTag: "Tag",
      colTitle: "Tajuk",
      colPreview: "Pratonton",
      colActive: "Aktif",
      colActions: "Tindakan",
      sectionContent: "Kandungan sepanduk",
      sectionAppearance: "Gambar dan penampilan",
      sectionPublishing: "Susunan dan penerbitan",
      updateSuccess: "Sepanduk dikemas kini",
      createSuccess: "Sepanduk dicipta",
      saveFailed: "Gagal menyimpan sepanduk",
      deleteConfirm: "Padam sepanduk ini?",
      deleteSuccess: "Sepanduk dipadam",
      deleteFailed: "Gagal memadam sepanduk",
      fieldTitle: "Tajuk",
      titleRequired: "Tajuk diperlukan",
      titlePlaceholder: "cth. Tawaran Istimewa Raya",
      fieldTag: "Tag",
      tagRequired: "Tag diperlukan",
      tagPlaceholder: "cth. Promosi",
      fieldTagColor: "Warna Tag",
      fieldImageUrl: "Gambar Sepanduk",
      fieldOrder: "Susunan",
      fieldActive: "Aktif",
      preview: "Pratonton",
      previewImageAlt: "Pratonton sepanduk",
    },
    paymentMethods: {
      title: "Kaedah Pembayaran",
      subtitle: "Konfigurasikan get pembayaran dan kelayakan API",
      statTotal: "Jumlah kaedah",
      statActive: "Aktif",
      statInactive: "Tidak aktif",
      statSandbox: "Kotak pasir",
      statBadgeOverall: "Keseluruhan",
      statBadgeActive: "Diaktifkan",
      statBadgeInactive: "Dinyahaktifkan",
      statBadgeSandbox: "Ujian",
      addMethod: "Tambah Kaedah",
      editTitle: "Edit Kaedah Pembayaran",
      newTitle: "Kaedah Pembayaran Baharu",
      colProvider: "Get",
      colMethod: "Kaedah",
      colDisplayName: "Nama Paparan",
      colApiKey: "Kunci API",
      colQrCode: "Kod QR",
      colStatus: "Aktif",
      colActions: "Tindakan",
      sectionGeneral: "Butiran umum",
      sectionCredentials: "Kelayakan get",
      sectionDisplay: "Paparan dan status",
      formProvider: "Get Pembayaran",
      formMethod: "Kaedah Pembayaran",
      formDisplayName: "Nama Paparan",
      formApiKey: "Kunci API",
      formApiKeyPlaceholder: "Masukkan kunci API (disimpan dengan penyulitan)",
      formApiSecret: "Rahsia API",
      formApiSecretPlaceholder: "Masukkan rahsia API",
      formCollectionId: "ID Koleksi (Billplz) / ID Profil (Hyperswitch)",
      formMerchantId: "ID Peniaga (Fiuu)",
      phMerchantId: "cth. ID Peniaga Fiuu",
      formWebhookSecret: "Rahsia Webhook",
      formWebhookSecretPlaceholder: "Masukkan rahsia pengesahan webhook",
      formQrImageUrl: "URL Gambar Kod QR",
      formSortOrder: "Susunan",
      formIsActive: "Aktif",
      testConnection: "Uji sambungan",
      confirmDelete: "Padam konfigurasi kaedah pembayaran ini?",
      createSuccess: "Kaedah pembayaran dicipta",
      updateSuccess: "Kaedah pembayaran dikemas kini",
      deleteSuccess: "Kaedah pembayaran dipadam",
      saveFailed: "Gagal menyimpan",
      deleteFailed: "Gagal memadam",
      testFailed: "Ujian sambungan gagal",
      phSelectProvider: "Pilih penyedia",
      phSelectMethod: "Pilih kaedah",
      phDisplayName: "cth. Billplz FPX, Bayaran Tunai",
      phCollectionId: "cth. ID Koleksi Billplz",
      phQrUrl: "https://… (URL ke gambar kod QR)",
      colQrBadge: "QR",
      qrPreviewAlt: "Pratonton kod QR",
      providerBillplz: "Billplz (FPX/Kad)",
      providerToyyibpay: "ToyyibPay",
      providerStripe: "Stripe",
      providerManual: "Manual / Tunai",
      providerQrStatic: "Kod QR Statik",
      providerGrabpay: "GrabPay Terus",
      providerBoost: "Boost",
      providerTng: "Touch 'n Go eWallet",
      providerHyperswitch: "Hyperswitch",
      providerFiuu: "Fiuu (Razer Merchant Services)",
      providerCustom: "Penyedia Tersuai",
      methodFpx: "FPX",
      methodVisa: "Visa / MasterCard",
      methodGrabpay: "GrabPay",
      methodCash: "Tunai",
      methodEwallet: "eWallet",
      methodTng: "Touch 'n Go",
      methodBoost: "Boost",
      methodQr: "Kod QR (Statik)",
    },
    deliveryProviders: {
      formSandboxMode: "Mod ujian",
      sandbox: "Persekitaran ujian",
      production: "Produksi",
      sandboxModeHint: "Menggunakan persekitaran ujian penyedia. Matikan hanya selepas menyediakan kelayakan produksi.",
      title: "Penyedia Penghantaran",
      subtitle: "Konfigurasikan integrasi API penghantaran dan tetapan liputan",
      statTotal: "Jumlah penyedia",
      statActive: "Aktif",
      statInactive: "Tidak aktif",
      statSandbox: "Ujian",
      statBadgeOverall: "Semua konfigurasi",
      statBadgeActive: "Sedang digunakan",
      statBadgeInactive: "Dijeda",
      statBadgeSandbox: "Konfigurasi ujian",
      addProvider: "Tambah Penyedia",
      editTitle: "Edit Penyedia Penghantaran",
      newTitle: "Penyedia Penghantaran Baharu",
      colProvider: "Platform",
      colDisplayName: "Nama",
      colApiKey: "Kunci API",
      colBaseUrl: "Endpoint API",
      colCoverage: "Liputan",
      colStatus: "Aktif",
      colActions: "Tindakan",
      sectionGeneral: "Maklumat umum",
      sectionCredentials: "API & kelayakan",
      sectionOperations: "Tetapan perkhidmatan",
      formProvider: "Platform Penghantaran",
      formDisplayName: "Nama Paparan",
      formApiKey: "Kunci API",
      formApiKeyPlaceholder: "Masukkan kunci API",
      formApiSecret: "Rahsia API",
      formApiSecretPlaceholder: "Masukkan rahsia API",
      formWebhookSecret: "Rahsia Webhook",
      formWebhookSecretPlaceholder: "Masukkan rahsia webhook",
      formBaseUrl: "URL Asas API",
      formCoverageKm: "Radius Liputan",
      formSortOrder: "Susunan",
      formIsActive: "Aktif",
      testConnection: "Uji sambungan API",
      confirmDelete: "Padam penyedia penghantaran ini?",
      createSuccess: "Penyedia penghantaran ditambah",
      updateSuccess: "Penyedia penghantaran dikemas kini",
      deleteSuccess: "Penyedia penghantaran dibuang",
      saveFailed: "Gagal menyimpan",
      deleteFailed: "Gagal memadam",
      testFailed: "Ujian API gagal",
      phSelectProvider: "Pilih penyedia",
      phDisplayName: "cth. Lalamove Same Day",
      phBaseUrl: "https://rest.lalamove.com",
      unitKm: "km",
      coverageKm: "{{km}} km",
      providerLalamove: "Lalamove",
      providerGrabexpress: "GrabExpress",
      providerFoodpanda: "Penghantaran Foodpanda",
      providerPandago: "PandaGo",
      providerMyposrider: "MyPOS Rider",
      providerManual: "Manual (dalaman)",
      providerCustom: "API Tersuai",
    },
    smsProviders: {
      title: "Penyedia SMS",
      subtitle: "Konfigurasikan integrasi API SMS/OTP dan keutamaan failover",
      statTotal: "Jumlah penyedia",
      statActive: "Aktif",
      statHealthy: "Sihat",
      statInactive: "Tidak aktif",
      statBadgeOverall: "Semua konfigurasi",
      statBadgeActive: "Sedang digunakan",
      statBadgeHealthy: "Sambungan sihat",
      statBadgeInactive: "Dijeda",
      addProvider: "Tambah Penyedia",
      editTitle: "Edit Penyedia SMS",
      newTitle: "Penyedia SMS Baharu",
      colProvider: "Penyedia",
      colDisplayName: "Nama",
      colSortOrder: "Keutamaan",
      colHealthy: "Status Kesihatan",
      colStatus: "Aktif",
      colActions: "Tindakan",
      sectionGeneral: "Maklumat umum",
      sectionCredentials: "API & kelayakan",
      sectionOperations: "Tetapan perkhidmatan",
      healthy: "Sihat",
      unhealthy: "Tidak Sihat",
      formProvider: "Penyedia SMS",
      formDisplayName: "Nama Paparan",
      formApiKey: "Kunci API",
      formApiKeyPlaceholder: "Masukkan kunci API",
      formApiSecret: "Rahsia API",
      formApiSecretPlaceholder: "Masukkan rahsia API",
      formWebhookSecret: "Rahsia Webhook",
      formWebhookSecretPlaceholder: "Masukkan rahsia webhook",
      formAccountSid: "Account SID",
      formAccountSidPlaceholder: "Masukkan Account SID",
      formAuthToken: "Auth Token",
      formAuthTokenPlaceholder: "Masukkan Auth Token",
      formMessagingServiceSid: "Messaging Service SID (pilihan)",
      formMessagingServiceSidHint: "Hanya diperlukan jika anda hantar melalui Messaging Service, bukan satu nombor tunggal.",
      formMessagingServiceSidPlaceholder: "Masukkan Messaging Service SID",
      formSms123Email: "E-mel Akaun sms123.net",
      formSms123EmailHint: "E-mel yang didaftarkan untuk akaun sms123.net anda — diperlukan untuk menghantar templat untuk kelulusan.",
      formSms123EmailPlaceholder: "cth. anda@syarikat.com",
      submitTemplateTooltip: "Hantar templat untuk kelulusan",
      submitTemplateTitle: "Hantar Templat ke sms123.net",
      submitTemplateOk: "Hantar",
      submitTemplateHint: "Ini hanya menghantar permintaan — sms123.net menghantar hasil kelulusan (diluluskan/ditolak) ke callback mereka sendiri, bukan di sini. Semak dashboard sms123.net anda untuk keputusan.",
      templateTitleLabel: "Tajuk Templat",
      templateTitlePlaceholder: "cth. Kod Pengesahan OTP",
      templateContentLabel: "Kandungan Mesej",
      templateContentHint: "Guna sintaks ruang letak sms123.net SENDIRI (%%) untuk bahagian berubah — BUKAN ruang letak {code}/{minutes} dari Tetapan > Templat SMS (itu digantikan oleh sistem kami sendiri sebelum menghantar, sms123.net tidak pernah nampak). Sertakan juga awalan pendedahan harga dan nama syarikat anda, cth. \"RM0 NamaSyarikat : ...\" — disahkan terus oleh sokongan sms123.net, bukan dalam dokumentasi awam mereka.",
      templateContentPlaceholder: "cth. RM0 KawKaw : Your verification code is %%. It expires in %% minutes.",
      templateSubmitFailed: "Gagal menghantar templat",
      formBaseUrl: "URL Asas API",
      formConfigJson: "Konfigurasi (JSON)",
      formSortOrder: "Keutamaan Failover",
      formIsActive: "Aktif",
      sortOrderHint: "Nombor lebih kecil dicuba dahulu",
      configJsonHint: "Ini ialah tetapan permintaan yang sama seperti borang mudah di atas, dalam bentuk JSON mentah — untuk kes khas yang tidak dapat diisi melalui borang. Boleh tukar balik ke borang mudah bila-bila masa.",
      builtInNote: "{{provider}} sudah dikonfigurasikan lebih awal — tiada apa perlu diisi di bawah selain kelayakan anda.",
      customConfigTitle: "Tetapan Permintaan",
      customConfigHint: "Beritahu kami apa nak hantar dan cara baca respons — tiada pengekodan diperlukan.",
      contentTypeLabel: "Hantar data sebagai",
      contentTypeForm: "Medan borang (kebanyakan penyedia)",
      contentTypeQuery: "Parameter URL (GET) — cth. sms123.net",
      contentTypeJson: "JSON",
      authStyleLabel: "Cara hantar API Key",
      authStyleNone: "Sebagai salah satu medan di bawah",
      authStyleBearer: "Sebagai header Authorization",
      bodyFieldsLabel: "Medan untuk dihantar",
      fieldNamePlaceholder: "Nama medan (cth. recipients)",
      customValuePlaceholder: "Teks tetap untuk dihantar",
      addField: "+ Tambah Medan",
      value_phone: "Nombor Telefon",
      value_message: "Teks Mesej",
      value_apiKey: "API Key",
      value_apiSecret: "API Secret",
      value_referenceId: "ID Permintaan Unik (dijana automatik)",
      value_custom: "Teks tetap…",
      advancedErrorHandling: "Membaca respons (pilihan)",
      advancedErrorHandlingHint: "Hanya diperlukan jika penyedia sentiasa balas berjaya (HTTP 200) walaupun gagal, dengan hasil sebenar di dalam badan respons.",
      successFieldLabel: "Nama medan kejayaan",
      successFieldPlaceholder: "cth. status",
      successValueLabel: "Nilai yang bermaksud berjaya",
      successValuePlaceholder: "cth. ok",
      errorCodeFieldLabel: "Nama medan kod ralat",
      errorCodeFieldPlaceholder: "cth. msgCode",
      permanentCodesLabel: "Kod ralat yang bermaksud \"nombor tidak sah, jangan cuba lagi\"",
      permanentCodesHint: "Dipisahkan koma. Biarkan kosong jika tidak pasti — kod yang tidak dikenali dianggap boleh dicuba semula secara lalai.",
      transientCodesLabel: "Kod ralat yang bermaksud \"cuba penyedia seterusnya\"",
      transientCodesHint: "Dipisahkan koma, cth. baki tidak mencukupi atau kelayakan tidak sah.",
      codesPlaceholder: "cth. E00242, E00250",
      editRawJson: "Lanjutan: edit JSON mentah",
      backToSimpleForm: "← Kembali ke borang mudah",
      testConnection: "Hantar SMS ujian",
      testPhoneLabel: "Nombor telefon ujian",
      testPhoneHint: "Biarkan kosong untuk sahkan kelayakan sahaja (Twilio sahaja, tiada mesej dihantar, tiada kos). Masukkan nombor untuk hantar SMS ujian sebenar — diperlukan untuk penyedia sms123/tersuai, yang tiada pengesahan tanpa kos.",
      testPhonePlaceholder: "cth. +60123456789",
      sendTest: "Hantar Ujian",
      confirmDelete: "Padam penyedia SMS ini?",
      createSuccess: "Penyedia SMS ditambah",
      updateSuccess: "Penyedia SMS dikemas kini",
      deleteSuccess: "Penyedia SMS dibuang",
      saveFailed: "Gagal menyimpan",
      deleteFailed: "Gagal memadam",
      testFailed: "Ujian SMS gagal",
      phSelectProvider: "Pilih penyedia",
      phDisplayName: "cth. Twilio Utama",
      phBaseUrl: "https://api.sms123.example.com/send",
      phConfigJson: '{"content_type":"query","method":"GET","auth_style":"none","body_template":{"apiKey":"{{apiKey}}","recipients":"{{phone}}","messageContent":"{{message}}","referenceID":"{{referenceId}}"},"success_check":{"field":"status","equals":"ok"},"error_code_field":"msgCode","permanent_error_codes":["E00242"],"transient_error_codes":["E00250","E00359"]}',
      providerTwilio: "Twilio",
      providerSms123: "sms123",
      providerCustom: "API Tersuai",
    },
    login: {
      termsAndConditions: "Terma dan Syarat",
      privacyPolicy: "Dasar Privasi",
    },
  },
};
